export type Locale = "zh-Hant" | "zh-Hans" | "en";

/** Portal locales. Add a locale here → Admin strategy copy editor grows a matching name/blurb pair. */
export const LOCALES: Locale[] = ["zh-Hant", "zh-Hans", "en"];
export const LOCALE_LABEL: Record<Locale, string> = {
  "zh-Hant": "繁中",
  "zh-Hans": "简中",
  en: "EN",
};

type Dict = Record<string, string>;

const zhHant: Dict = {
  product: "Kairos",
  tagline: "機構級交易作業系統",
  subtitle: "客戶自有戶口 · 系統代為執行 · 同一套引擎通往 MT5 與交易所",
  login: "登入",
  register: "開戶",
  logout: "登出",
  dashboard: "控制台",
  admin: "管理後台",
  servers: "交易伺服器",
  accounts: "交易戶口",
  strategies: "策略",
  copy: "跟單",
  referral: "介紹人",
  unbind: "解綁",
  allowCopy: "開放跟單",
  applyCopyOffer: "申請開放跟單",
  editCopyOffer: "編輯名稱／簡介",
  copyOfferTitle: "策略名稱",
  copyOfferDescription: "簡單描述",
  copyOfferSubmit: "提交申請",
  copyOfferPending: "申請開放跟單待批中",
  copyOfferRejected: "開放跟單申請被拒",
  copyOfferApprovedHint: "已獲批開放跟單權，可自行開／關。改名稱／簡介即時生效。",
  copyOfferWorking: "正在提交申請…",
  copyOfferSaving: "正在儲存…",
  copyOfferOk: "已提交開放跟單申請，待 Admin 批核。",
  copyOfferUpdated: "已更新跟單名稱／簡介。",
  copyOfferApproveOk: "已批准開放跟單",
  copyOfferRejectOk: "已拒絕開放跟單申請",
  copyOfferRejectConfirm: "拒絕 {email} #{login} 嘅開放跟單申請？",
  revokeCopyOffer: "收回跟單權",
  revokeCopyOfferConfirm: "收回 {email} #{login} 嘅開放跟單權？客戶要重新申請先可以再開。",
  revokeCopyOfferOk: "已收回跟單權",
  copyOfferNeedApproved: "尚未獲批開放跟單權，請先申請",
  needOnlineForCopy: "戶口要先連上 MT5，先可以轉做 master。",
  copyFollowersBlockOff: "仍有 {n} 位客戶跟緊呢個戶口，對方取消跟單後先可以關閉「開放跟單」。",
  copyFollowersBlockUnbind: "仍有 {n} 位客戶跟緊呢個戶口，對方取消跟單後先可以關閉跟單再解綁。",
  unbindNeedDisableCopy: "請先關閉「開放跟單」再解綁。",
  unbindConsentTitle: "解綁戶口確認與服務終止說明",
  unbindConsentVersion: "v1",
  unbindConsentAgree: "我已閱讀並同意上述解綁說明。",
  unbindConsentConfirm: "同意並解綁",
  unbindConsentBody:
    "1. 解綁會終止 Kairos 對此交易戶口嘅執行與策略／跟單託管服務；平台唔代管您嘅資金，資金仍存放於您選擇嘅經紀商戶口。\n" +
    "2. 解綁後，此戶口上已啟用嘅策略分配同跟單連結會一併移除或停用；系統唔會繼續代您開倉、平倉或跟單。\n" +
    "3. 解綁成功後，系統會一次過向您交返 Server name（經紀商）、Login 同 Master 密碼（只此一次／並存入消息中心）。請即刻自行妥善保存；之後平台唔保證可再顯示完整明文憑證。\n" +
    "4. 您有責任喺解綁後自行管理該經紀商戶口、密碼同風險；若憑證遺失、遭第三方使用或經紀商拒絕連線，後果由您自行承擔。\n" +
    "5. 解綁唔等於經紀商銷戶，亦不保證可即時重新綁定；重新綁定可能受場地開關、配額、審批政策、戶口狀態或系統維護影響。\n" +
    "6. 若此戶口仍開放跟單，或仍有其他客戶跟緊，您必須先待跟單者取消跟單並關閉「開放跟單」，先可以解綁。\n" +
    "7. 您確認已閱讀並理解上述說明，同意終止本戶口喺 Kairos 嘅綁定與相關服務。",
  investor: "投資者密碼",
  bind: "綁定戶口",
  email: "電郵",
  password: "密碼",
  showPassword: "顯示密碼",
  hidePassword: "隱藏密碼",
  invite: "邀請碼",
  invitePlaceholder: "KAIROS-2026 或 8 位推薦碼",
  code: "驗證碼",
  verify: "驗證電郵",
  locale: "語言",
  equity: "權益",
  balance: "餘額",
  credit: "信用額",
  positions: "持倉",
  status: "狀態",
  alias: "別名",
  environment: "環境",
  search: "搜尋經紀商",
  import: "匯入",
  manual: "手動新增",
  ping: "Ping",
  save: "儲存",
  enabled: "啟用",
  demo: "模擬",
  live: "真實",
  host: "主機",
  port: "埠",
  official: "官方名稱（學生不可見）",
  company: "公司",
  actions: "操作",
  mtLogin: "MT5 帳號",
  accountShort: "帳號",
  masterPassword: "主密碼",
  studentHint: "學生只會見到別名，不會見到真實伺服器地址。",
  fetchMt5: "用 mt5rest 搜尋",
  fetchMt4: "用 mt4rest 搜尋",
  uploadDat: "上傳 servers.dat",
  uploadSrv: "上傳 .srv / servers.ini",
  requireInvite: "註冊必須邀請碼",
  socialLogin: "社交登入",
  socialLoginHint: ".env 填齊之後，仲要喺度開先會喺登入／開戶頁出掣。關咗連 API 都拒。",
  googleLoginEnabled: "允許 Google 登入／開戶",
  telegramLoginEnabled: "允許 Telegram 登入／開戶",
  googleEnvReady: ".env 已填 Google Client。",
  googleEnvMissing: "未填 GOOGLE_CLIENT_ID／SECRET，開咗都未用得。",
  telegramEnvReady: ".env 已填 Telegram Bot。",
  telegramEnvMissing: "未填 TELEGRAM_BOT_TOKEN／USERNAME，開咗都未用得。",
  adminSettings: "系統設定",
  adminSettingsHint: "全系統 config。改完撳頁底儲存一次過寫入。閃動秒數套用所有用戶；每人仍可喺自己設定關閉效果。",
  loadFailed: "載入失敗",
  saving: "儲存中…",
  connectionQuotaInvalid: "請輸入 1 至 100 之間嘅連線數",
  demoTrialInvalid: "請輸入 0 至 365 之間嘅日數",
  riskConsentVersionInvalid: "請填寫風險條款版本",
  adminStrategies: "策略產品",
  adminStrategiesHint: "開賣、客戶卡露出邊啲參數、catalog 預設、邊戶喺跑。關產品唔會自動平倉；改預設唔會覆寫現有戶口。",
  catalogOpen: "開賣",
  catalogClosed: "軟關",
  catalogUnavailable: "呢條策略暫時未向客戶開放。",
  clientSurface: "客戶表面",
  clientSurfaceHint: "撳表面循環：常用 → 進階 → 鎖定 → 隱藏。↑↓ 改順序。儲存先生效。",
  surfaceSimple: "常用",
  surfaceAdvanced: "進階",
  surfaceLocked: "鎖定",
  surfaceHidden: "隱藏",
  liveBook: "Live book",
  liveBookHint: "唔顯示真實 host／master。參數列只顯示同 catalog 唔同嘅 key。",
  openProduct: "打開",
  softCloseHint: "關賣之後客戶目錄唔再出現；已跑戶口繼續，直至自己停或你硬停。",
  softCloseConfirm: "而家有 {n} 個戶口喺跑。軟關只係唔再賣畀新客戶，唔會停佢哋。確定？",
  softCloseActive: "軟關中：{n} 個戶口仍然喺跑。",
  hardStop: "硬停全部跑緊",
  hardStopHint: "只停策略，唔自動平倉。",
  hardStopConfirm: "將 {name} 嘅 {n} 個跑緊戶口停咗（唔平倉）。確定？",
  hardStopDone: "已停 {n} 個戶口。",
  catalogDefault: "預設值",
  defaultsNotLive: "改預設只影響新啟用同客戶撳重設；現有 allocation 唔會被覆寫。",
  followCatalog: "跟 catalog",
  noLiveAllocations: "未有戶口配置呢條策略。",
  advancedParams: "進階參數",
  schemaSaved: "已儲存產品設定。",
  paramKey: "參數",
  clientPreview: "客戶卡預覽",
  vsCatalog: "相對 catalog",
  strategyNameField: "策略名稱",
  strategyBlurbField: "簡介說明",
  strategyCopyHint: "客戶策略卡顯示嘅名稱同介紹。跟系統語言列表自動出欄；slug 唔可以改。",
  editStrategyCopy: "編輯名稱／簡介",
  collapseStrategyCopy: "收起名稱／簡介",
  nameZhHant: "名稱 · 繁中",
  nameZhHans: "名稱 · 简中",
  nameEn: "Name · EN",
  blurbZhHant: "簡介 · 繁中",
  blurbZhHans: "简介 · 简中",
  blurbEn: "Blurb · EN",
  brokerLogs: "經紀商指令",
  brokerLogsJournal: "指令記錄",
  brokerLogsHint: "引擎打去 mt4rest／mt5rest 嘅指令同回傳。每行會記邊頁／邊個功能打出嚟。密碼同 Connect URL 唔會寫入。Worker keep-alive 唔寫入資料庫；報價預設收埋。",
  brokerLogsChatter: "顯示報價／keep-alive",
  brokerLogsQuery: "搜尋 command／送出／回傳／失敗",
  brokerLogsHours: "時間範圍",
  brokerErrorsOnly: "只睇失敗",
  brokerCallerPage: "來源頁",
  brokerCallerFeature: "功能",
  brokerCaller: "來源",
  brokerClearFilters: "清除所有篩選",
  brokerShowingCount: "顯示 {n} 筆",
  brokerRest: "REST 探查",
  brokerRestHint: "用人手打 mt4rest／mt5rest 讀取。瀏覽器唔直連經紀商；寫入、改密、Connect 唔開放。列表回傳用表格顯示，方便對「攞錯／攞唔到」。",
  brokerRestAccount: "已綁戶口",
  brokerRestSend: "發送",
  brokerRestNeedAccount: "呢個指令要用引擎而家嘅戶口連線，請先揀已綁戶口。",
  brokerRestTable: "表格",
  brokerRestJson: "JSON",
  brokerRestRows: "{n} 列",
  brokerRestGroupServer: "伺服器",
  brokerRestGroupAccount: "帳戶",
  brokerRestGroupPositions: "持倉",
  brokerRestGroupHistory: "歷史",
  brokerRestGroupQuotes: "報價",
  brokerRestPickCommand: "揀一個指令",
  brokerRestSending: "發送中…",
  brokerRestEmpty: "未有回傳。揀指令之後撳發送。",
  last1h: "過去 1 小時",
  last6h: "過去 6 小時",
  last24h: "過去 24 小時",
  last7d: "過去 7 日",
  allPlatforms: "全部平台",
  allCommands: "全部指令",
  resultOk: "成功",
  resultError: "失敗",
  durationMs: "耗時",
  requestBody: "送出",
  responseBody: "回傳",
  tickFlashSeconds: "數字閃動秒數",
  tickFlashSecondsHint: "權益／盈虧變動時背景閃動幾耐（0.15–3 秒）。Config key：tick_flash_seconds",
  tickFlashSecondsInvalid: "請輸入 0.15 至 3 之間嘅秒數",
  tickFlashEnabled: "數字閃動效果",
  tickFlashEnabledHint: "只影響你自己。Config key：tick_flash_enabled",
  seconds: "秒",
  minutes: "分鐘",
  idleTimeoutHint: "鍵盤滑鼠無操作幾耐之後自動登出。0 = 唔逾時。Config key：idle_timeout_seconds（預設 5 分鐘）",
  idleTimeoutInvalid: "請輸入 0 或以上嘅分鐘數",
  idleLoggedOut: "已超過無操作時間，請重新登入。",
  brokerLogRetentionHint: "經紀商指令 log 喺資料庫留幾耐。0 = 唔刪。Config key：broker_log_retention_days（預設 7 日）",
  brokerLogRetentionInvalid: "請輸入 0 至 365 之間嘅日數",
  days: "日",
  hours: "小時",
  passwordRotateHoursHint: "自動輪換 investor／master 嘅間距（小時）。0 = 唔自動。Config：investor_rotate_hours／master_rotate_hours；環境變數 INVESTOR_ROTATE_HOURS／MASTER_ROTATE_HOURS（預設 12）",
  passwordRotateHoursInvalid: "請輸入 0 至 8760 之間嘅小時數",
  bindRotatePasswords: "綁戶時改密（investor + master）",
  bindRotatePasswordsHint: "開：連線成功後改 investor 並輪換 master，成功先寫 DB。關：跳過改密，直接用客戶輸入嘅 master 存 DB。綁住期間客戶唔見 MT 密碼；解綁先一次過交返。Config：bind_rotate_passwords；環境變數 BIND_ROTATE_PASSWORDS（預設關）",
  autoRotateHint: "自動輪換間距由 Admin 系統設定（小時；0＝唔自動）",
  sessionKicked: "已在另一部電腦登入，呢度已被踢出。",
  empty: "暫無資料",
  connectOk: "已連線",
  connectFail: "連線失敗",
  googleSoon: "Google 登入稍後開放",
  home: "主頁",
  portfolio: "倉位",
  tasks: "任務",
  settings: "設定",
  floating: "浮動盈虧",
  winRate: "持倉勝率",
  trades: "交易次數",
  followers: "跟單人數",
  following: "正在跟",
  quotes: "報價",
  watchlist: "Watchlist",
  running: "運行中",
  stopped: "未啟用",
  hedge: "對沖模式 · 同品種可同時 BUY + SELL",
  reward: "獎勵",
  planned: "金流未接 · 完成度已即時計算",
  sessions: "裝置 session",
  currentDevice: "目前裝置",
  copyCode: "複製",
  liveProof: "Demo / Live 同一條綁定路徑，只換伺服器別名",
  pwdOk: "密碼策略已套用",
  pwdInvestorOk: "Investor 已套用",
  pwdInvestorDenied: "Investor 改密被拒",
  pwdMasterDenied: "Master 輪換被拒",
  pwdDenied: "經紀商禁用改密",
  pwdPending: "尚未輪換",
  pwdSkipped: "綁戶未改密（設定關閉）",
  bindOkSkipped: "已綁定。未改密，沿用你輸入嘅 master（只留引擎）。",
  boundNoMtPasswordsHint: "綁住期間唔顯示 master／investor；倉位同平倉喺 Kairos 處理。解綁時會一次過交返 Server／Login／Master。",
  unbindHandoffTitle: "解綁完成 · 請即刻保存憑證",
  unbindHandoffOnce: "請即刻複製保存。完整憑證亦已存入頂欄鐘仔「推送消息」，之後可回看。",
  unbindServerName: "Server name（經紀商）",
  unbindLogin: "Login",
  unbindMaster: "Master",
  unbindInvestor: "Investor",
  unbindInvestorMissing: "呢個戶口未有 investor（綁戶時可能跳過咗改密）。",
  unbindHandoffSaved: "我已保存",
  unbindFailed: "解綁失敗",
  copied: "已複製",
  rotateInvestor: "輪換 investor",
  rotateMaster: "輪換 master",
  copyInvestor: "複製 investor",
  masterInEngine: "Master 只留引擎",
  loading: "載入中…",
  pleaseLogin: "請先登入。",
  needAdmin: "需要管理員權限。",
  expandSidebar: "開啟側欄",
  collapseSidebar: "關閉側欄",
  language: "語言",
  accountsMenu: "戶口",
  navExecute: "執行",
  navGrowth: "增長",
  darkMode: "深色模式",
  roleClient: "客戶",
  roleAdmin: "管理員",
  referralCode: "推薦碼",
  avatar: "頭像",
  avatarHint: "揀一個預設頭像，會顯示喺頂欄同選單。",
  avatarAdminFixed: "管理員使用專用頭像，唔使揀。",
  changeAvatar: "更換頭像",
  marketsLive: "市場開市",
  connecting: "連接中…",
  loginTitle: "登入控制面",
  loginHint: "同一套 session 行門戶、引擎同 MT5 橋。密碼唔會經過瀏覽器直打經紀商。",
  loginFailed: "登入失敗",
  noAccount: "未有帳戶？",
  forgotPassword: "忘記密碼",
  forgotTitle: "重設登入密碼",
  forgotHint: "只重設 Kairos 門戶密碼，唔會改經紀商 Master／Investor。輸入已驗證電郵，我們會寄重設連結。",
  forgotSent: "如果此電郵已註冊，我們已寄出重設連結。連結 10 分鐘內有效。",
  forgotCheckTitle: "請檢查你的電郵",
  forgotCheckBody: "如果 {email} 已註冊，收件箱會有重設連結（10 分鐘內有效）。",
  sendResetLink: "發送重設連結",
  resetHint: "設定新的 Kairos 登入密碼。唔會改經紀商 Master／Investor。",
  resetInvalid: "重設連結無效或已過期。請重新申請。",
  devResetLink: "開發模式重設連結：{link}",
  orDivider: "或",
  resetPassword: "重設密碼",
  newPassword: "新密碼",
  confirmPassword: "確認新密碼",
  passwordMismatch: "兩次密碼不一致",
  resetOk: "密碼已重設，請用新密碼登入。",
  backToLogin: "返回登入",
  signInWithGoogle: "使用 Google 登入",
  signInWithTelegram: "使用 Telegram 登入",
  oauthNotConfigured: "未設定此登入方式。填好引擎環境變數後重啟即可。",
  oauthInviteHint: "新帳戶若需邀請碼，請先填寫再撳 Google／Telegram。",
  registerInviteHint: "電郵開戶同 Google／Telegram 共用呢個邀請碼。",
  emailRegister: "用電郵開戶",
  errGoogleDisabled: "Google 登入尚未設定。",
  errGoogleDenied: "已取消 Google 授權。",
  errGoogleNoEmail: "Google 帳戶沒有電郵。",
  errInviteRequired: "新帳戶需要邀請碼。請填邀請碼後再撳登入。",
  errOauthConflict: "此社交帳戶已綁其他用戶。",
  errGoogleFailed: "Google 登入失敗。",
  registerHint: "驗證電郵為繁中／簡中／英文對照。系統會記住你嘅語言。",
  registerFailed: "註冊失敗",
  verifyFailed: "驗證失敗",
  sendCode: "發送驗證碼",
  finishVerify: "完成驗證",
  codeSent: "驗證碼已發到 {email}",
  devCode: "開發模式驗證碼：{code}",
  hasAccount: "已有帳戶？",
  landingKicker: "Execution OS · MT5 · Exchange-ready",
  landingTitle: "機構級交易作業系統",
  landingAccent: "built for live markets.",
  landingBody: "錢留喺客戶自己經紀商。Kairos 只負責連線、風控、策略同落單。同一套控制台之後可以接到交易所。",
  enterSystem: "進入系統",
  haveAccount: "已有帳戶",
  pillar1: "多租戶門戶、邀請碼、雙設備 session，學生只見伺服器別名。",
  pillar2: "自建 MT5 REST。Demo / Live 只換 access 列表，唔換引擎。",
  pillar3: "每戶 keep-alive、持倉同步、多策略與跟單預位。",
  pillar4: "同一控制面預留交易所 API 與平台內賬，評審見到的是一套系統。",
  liveStack: "Live stack",
  nonCustodial: "Non-custodial first",
  nonCustodialBody: "Master password 只由系統交易。學生見到別名同 investor 視圖，唔會見到真實 server 名。",
  homeHint: "權益、倉、跟單人數由引擎同步。瀏覽器只打 Kairos API，唔直連經紀商。",
  online: "online",
  offline: "offline",
  accountDisabled: "已停用",
  copyPaused: "跟單已暫停",
  accountExpired: "已到期",
  accountBrokerDisabled: "經紀商已停用或過期此戶口，引擎已停止重連。請到綁定頁解綁後改綁新戶。",
  accountDemoExpired: "Demo 試用已到期，引擎已停止連線。",
  accountsLabel: "戶口",
  connection: "連線",
  miniBlotter: "迷你 blotter",
  allPositions: "全部倉位",
  blotterAccount: "戶",
  symbol: "品種",
  side: "方向",
  pnl: "盈虧",
  noPositionsHint: "暫無持倉。去策略頁啟用均線突破，或跟一個 Master。",
  goBind: "去綁定",
  bindNav: "綁定",
  noAccountsYet: "尚未綁戶。",
  allBoundEquity: "所有綁定戶合計",
  openCountHint: "{n} 張持倉",
  openWinHint: "開倉中盈利張數",
  engineFills: "引擎已送出的單",
  followingMasters: "正在跟 {n} 個 master",
  portfolioHint: "持倉與資金由引擎 keep-alive 同步。揀戶口卡睇該戶 blotter。",
  portfolioExpiredTitle: "戶口連接權限已到期",
  portfolioExpiredHint: "此戶口連接系統的權限已到期，引擎已停止連線。如場上仍有訂單，請到經紀商自行處理。",
  noAccountsBind: "尚未綁戶。去「戶口 → 綁定」綁 MT5／MT4。",
  blotter: "持倉 blotter",
  blotterCountLive: "{live} 持倉",
  blotterCountSplit: "{n} 張單，{live} 持倉，{pending} 掛單",
  lots: "手數",
  openPrice: "開倉價",
  currentPrice: "現價",
  stopLoss: "止損",
  takeProfit: "止盈",
  action: "操作",
  source: "來源",
  openTime: "開倉時間",
  closePosition: "平倉",
  closeThisTicket: "平倉",
  closeThisTicketConfirm: "確定平呢張 {symbol} #{ticket}？",
  closeThisTicketDone: "已送出平倉。",
  deletePendingOrder: "刪除",
  deletePendingOrderConfirm: "確定刪除 {symbol} #{ticket} 呢張掛單？",
  deletePendingOrderDone: "已刪除掛單。",
  noPositionsHedge: "暫無持倉。同品種可同時 BUY + SELL（對沖）。",
  blotterNote: "現價用該戶報價（多單 bid、空單 ask）。盈虧係浮動，以經紀商戶口為準。",
  sectionCollapse: "收起",
  sectionExpand: "展開",
  batchOps: "批量操作",
  batchGroupCount: "{n} 組",
  batchTotalTickets: "總單量",
  batchTotalLots: "總手數",
  batchTotalPnl: "總盈虧",
  batchWinTotal: "浮盈單總計",
  batchLossTotal: "浮虧單總計",
  batchLegSummary: "{n} 張 共 {lots} 手",
  batchCloseWin: "只平浮盈",
  batchCloseLoss: "只平浮虧",
  batchCloseAll: "全部平倉",
  batchCloseWinConfirm: "確定平晒 {symbol} {side} 嘅 {n} 張盈利單（共 {lots} 手）？",
  batchCloseLossConfirm: "確定平晒 {symbol} {side} 嘅 {n} 張虧損單（共 {lots} 手）？",
  batchCloseAllConfirm: "確定平晒 {symbol} {side} 全部 {n} 張（共 {lots} 手）？",
  batchCloseDone: "已送出 {n} 張平倉。",
  batchClosePartialFailed: "{n} 張平倉失敗。",
  batchEmpty: "暫無可批量平倉嘅持倉（掛單唔計）。",
  priceCandles: "價格 K 線",
  priceCandlesHint: "中間拖左右/上下平移；右邊價位刻度上拉放大、下拉縮細 K 線；timeline 拖右放大、拖左縮細；手機雙指左右 pinch 時間、上下 pinch 價位（雙擊重置）。持倉開倉價離開可見 bar 仍顯示橫線同左 label；hover/click bar 左上角明細卡。",
  priceCandlesTipOpen: "開倉",
  priceCandlesTipClose: "平倉",
  priceCandlesPinned: "已固定",
  priceCandlesUnpin: "取消固定",
  priceCandlesClickPin: "Click 固定",
  priceCandlesDragPanel: "拖動面板",
  priceCandlesCollapsePanel: "收起控制面板",
  priceCandlesExpandPanel: "展開控制面板",
  priceCandlesLoadFailed: "圖表暫時讀唔到。",
  priceCandlesLoadOlder: "載入更舊 K 線",
  priceCandlesLoadOlderBusy: "載入更舊 K 線中…",
  priceCandlesLoadOlderOk: "已加入 {n} 根 K 線 · 最早 {time}",
  priceCandlesLoadOlderEmpty: "Broker 冇更舊 K 線",
  priceCandlesLoadOlderFailed: "載入失敗：{error}",
  priceCandlesLive: "LIVE",
  priceCandlesNow: "現在",
  priceCandlesLiveOrders: "持倉",
  priceCandlesHistoryToggle: "平倉記錄天數",
  priceCandlesHistoryAllHint: "all 最多顯示 500 筆平倉",
  priceCandlesHistoryBusy: "載入平倉記錄中…",
  priceCandlesHistoryOk: "已載入 {n} 筆平倉記錄",
  priceCandlesHistoryEmpty: "呢段時間冇平倉記錄",
  priceCandlesHistoryFailed: "平倉記錄載入失敗：{error}",
  pendingStop: "Stop",
  pendingLimit: "Limit",
  pendingStopLimit: "Stop Limit",
  quotesAfterPositions: "暫無報價。呢個戶口暫時冇持倉品種。",
  floatingShort: "浮動",
  allocationHint: "同一戶口可同時跑多條策略，各自 magic／comment，倉位互唔相平。第一條用來打通開平倉。",
  bindFirst: "請先喺「戶口 → 綁定」綁定戶口。",
  maBreakout: "均線突破",
  maBreakoutBlurb: "Fast MA 上穿 Slow MA 開多，下穿開空。用來證明引擎真係開得到、平得到，唔係回測圖。",
  xauHedge: "黃金對沖網格",
  xauHedgeBlurb: "隨機開第一張金倉。順勢走滿距離就同向加倉並把整籃 SL 鎖在打和價＋賺點；逆勢就反向對沖，兩條價位線上嚴格交替加倉（Fibonacci 手數），打和＋trailing 一次過全平，冷卻再開新局。MT4／MT5 hedge。",
  stepPoints: "距離（點）",
  profitPoints: "賺幾點",
  volumeMult: "第2張倍率（其後 Fibonacci）",
  cooldownSec: "冷卻秒",
  trailPct: "Trailing %",
  maxLevels: "單局最多層",
  forceBeSl: "強制打和SL價位",
  forceBeSlHint: "關：Path A 有新成交票先改一次經紀商 SL。開：發現票面 SL 同計算值唔同時先改。",
  magicCommentHint: "落單標記。引擎用 magic 或 comment 開頭認倉。magic 可以係 0（此時只靠 comment 認倉，唔好同人手單撞）。唔好同跟單 Kc 撞；改之前請平晒用舊標記嘅單。",
  roundPhase: "本局",
  moreStrategies: "更多策略",
  moreStrategiesHint: "allocation book 已預位。下一條策略只加定義 + worker 分支，唔使改門戶結構。",
  updateParams: "更新參數",
  assignAccount: "配置到此戶",
  paramsHint: "停止後先改參數，再撳配置到此戶寫入引擎。轉戶口會丟棄未配置嘅改動。",
  stopToEdit: "跑緊唔可以改參數。請先停止。",
  insufficientCapital: "權益不足：需要 {need}，而家 {have}",
  capitalRequiredHint: "啟用時戶口權益要達標。",
  symbolRequired: "請填寫品種。",
  paramsSaved: "已寫入此戶並開始跑。",
  stop: "停止",
  positionDetails: "持倉明細",
  positionTicketCount: "{n}張",
  positionSummaryLine: "{n}張 · {lots}手",
  hedgePnlNote: "本策略同時持有買賣對沖，單邊損益會互相抵銷；實際風險看淨浮盈與期間損益。",
  noStrategyPositions: "呢條策略暫無持倉。",
  pauseTrading: "暫停交易",
  resumeTrading: "恢復交易",
  tradePausedHint: "已暫停落單；持倉仍會顯示，可一鍵平倉。",
  tradePausedBadge: "已暫停落單",
  closeStrategyPositions: "一鍵平倉",
  closeStrategyPositionsConfirm: "確定平倉以下呢條策略嘅持倉？唔會平其他策略或人手單。",
  closeStrategyConfirmAction: "確定平倉",
  closeStrategyWorking: "平倉緊，請稍候…",
  closeStrategyResultTitle: "平倉結果",
  closeStrategyClosedCount: "已平 / 請求",
  closeStrategyFailedCount: "失敗",
  closeStrategyLotsLabel: "已平手數",
  closeStrategyProfitLabel: "浮盈（平倉前）",
  closeStrategyLotsSum: "{lots}手",
  closeStrategyProfitSum: "浮盈 {pnl}",
  closeStrategyItemOk: "已平",
  closeStrategyItemFail: "失敗",
  closeStrategyDone: "完成",
  strategyPositionsClosed: "已平倉呢條策略嘅持倉。",
  tradingPaused: "已暫停呢條策略落單。",
  tradingResumed: "已恢復呢條策略落單。",
  resetParams: "重設",
  stoppedKeepParams: "已停止此戶策略，參數保留。",
  paramsReset: "已還原策略預設值（只改畫面）。要寫入引擎先撳配置到此戶；轉戶口會丟棄未配置嘅改動。",
  saveFailed: "儲存失敗",
  copyHint: "一個 follower 可跟多個 master。同品種可同時 BUY+SELL，唔會合成一張。只跟原創倉，唔跟已經係 copy 嘅單。",
  followWith: "用 #{login} 去跟",
  copyFollowerAccount: "跟單戶口",
  copyDefaultWeight: "預設比例 %",
  copyControlHint: "下面「我的跟單／複製持倉／跟單動態」都跟呢個戶口。",
  copyMasterTag: "(Master)",
  copyNoFollowerAccounts: "沒有可用嘅跟單戶口。已開放跟單嘅 Master 戶口唔可以再去跟其他人。",
  copyMasterCannotFollow: "已開放跟單嘅 Master 戶口唔可以用嚟跟其他人。",
  hedgeMode: "對沖模式",
  teamMaster: "團隊 Master",
  followingNow: "跟緊",
  followMasterPct: "跟此 Master",
  noMasters: "尚未有開放跟單嘅 Master。客戶要申請並經 Admin 批核後，先可以喺綁定頁開放跟單。",
  copyMarket: "訊號市集",
  myCopies: "我的跟單",
  myCopiesEmpty: "呢個戶口尚未跟任何 Master。可喺上面訊號市集揀一個跟。",
  copyBook: "複製持倉",
  copyBookCount: "{n} 張",
  copyFloating: "浮盈",
  copyActivity: "跟單動態",
  copyActivityHint: "系統代呢個戶口跟單嘅近期開倉。",
  copyRelations: "跟單關係 / 已複製倉",
  copyFills: "引擎跟單開倉記錄",
  noFills: "尚未有跟單開倉。",
  updateWeight: "更新比例",
  noCopied: "呢個戶口暫時冇複製持倉。",
  stopCopy: "停止跟單",
  stopCopyConfirm: "停止跟「{name}」？之後唔會再抄呢個 Master 嘅新倉；已有複製倉唔會自動平倉。",
  stopCopyOk: "已停止跟單",
  copyFailed: "跟單失敗",
  referralHint: "推薦碼可當註冊邀請碼，8 個英數字，可自訂。佣金同兌 USDT 之後接 internal_ledger。",
  customCode: "自訂推薦碼",
  customCodeHint: "必須剛好 8 個英文字母或數字，大小寫唔計。",
  saveCode: "儲存推薦碼",
  referrer: "介紹人",
  noReferrer: "未有介紹人",
  setReferrer: "改介紹人",
  unlinkReferrer: "解除連結",
  adminReferralsHint: "改客戶同介紹人嘅關係。用對方 8 位推薦碼連結，唔會形成循環。",
  referrerCode: "介紹人推薦碼",
  cycleBlocked: "會形成循環介紹",
  linkUpdated: "已更新介紹關係",
  cannotReferSelf: "不能自己介紹自己",
  invitedBy: "介紹人",
  inviteeCount: "已邀請人數",
  invited: "已邀請",
  nextStep: "下一步",
  taskCenter: "任務中心",
  goComplete: "去完成",
  copyReferral: "複製推薦碼",
  copied: "已複製",
  inviteList: "邀請名單",
  time: "時間",
  noInvitees: "尚未有人用你嘅碼註冊。",
  taskHint: "完成度即時計算。USDT 兌換標 planned——等平台內賬，唔好當已出金。",
  completed: "已完成",
  accruedUsdt: "應計 USDT",
  unsettled: "未結算",
  done: "完成",
  notDone: "未完成",
  rewardUsdt: "獎勵 {n} USDT",
  ledgerUnwired: "（未接金流）",
  ledgerPlanned: "internal_ledger 加分項",
  settingsHint: "語言喺左下角隨時切。綁戶／解綁去「戶口 → 綁定」。",
  passwordSection: "登入密碼",
  passwordSectionHint: "更改 Kairos 登入密碼。其他裝置會被登出。唔影響經紀商密碼。",
  setPasswordHint: "此帳戶而家用 Google／Telegram 登入。設定密碼之後可以用電郵登入。",
  currentPassword: "目前密碼",
  changePassword: "更改密碼",
  setPassword: "設定密碼",
  passwordChanged: "密碼已更新。",
  linkedLogins: "社交帳戶",
  linkedLoginsHint: "用電郵密碼登入之後，可以喺呢度綁定或解綁 Google／Telegram。解綁唔會刪帳戶。",
  googleAccount: "Google",
  telegramAccount: "Telegram",
  bindGoogle: "綁定 Google",
  bindTelegram: "綁定 Telegram",
  unbindGoogle: "解綁 Google",
  unbindTelegram: "解綁 Telegram",
  googleLinked: "已綁定",
  telegramLinked: "已綁定",
  notLinked: "未綁定",
  linkedOk: "已綁定。",
  unlinkedOk: "已解綁。",
  confirmUnlinkGoogle: "解綁 Google？之後要用電郵密碼或 Telegram 登入。",
  confirmUnlinkTelegram: "解綁 Telegram？之後要用電郵密碼或 Google 登入。",
  telegramDomainHint: "Telegram 小工具需要 BotFather 已登記嘅 HTTPS 網域；localhost 會顯示 Bot domain invalid。",
  bindMt5: "Bind MT5 · DEMO / LIVE",
  bindMt4: "Bind MT4 · DEMO / LIVE",
  bindHint: "揀別名，唔使填 host。需批核嘅環境會先試連，成功先交 Admin。綁住期間唔顯示 MT 密碼；解綁時一次過交返。",
  demoOpenTitle: "開 Demo（Admin）",
  demoOpenHint: "向經紀商申請 Demo，綁去下面揀嘅客戶（預設你自己）。瀏覽器唔直連 REST。唔支援嘅經紀商會失敗，請去官網開再用客戶綁定頁表單綁。伺服器列表唔會因為你自己配額滿而消失。",
  demoOpenBindTo: "綁去客戶",
  demoOpenBindSelf: "當前",
  demoOpenQuotaFull: "所選客戶 Demo 配額已滿。換另一個客戶，或去計劃方案加配額。",
  demoOpenSubmit: "開 Demo 並綁定",
  demoOpenWorking: "正在向經紀商申請 Demo，可能需要一分鐘…",
  demoOpenOk: "已開 Demo 並綁定。",
  demoOpenUnsupported: "呢間經紀商唔接受終端／API 開 Demo。請去官網開，再用客戶綁定頁表單綁。",
  demoOpenConnectFailed: "Demo 已開但連線失敗。請複製 Login／Master，用客戶綁定頁表單綁，或喺 MT 終端登入。",
  demoOpenHandoffTitle: "Demo 已開 · 請保存憑證",
  demoOpenAdvanced: "進階",
  demoOpenDeposit: "入金",
  demoOpenLeverage: "槓桿",
  demoOpenName: "姓名",
  demoOpenPhone: "電話",
  demoOpenNoServers: "目錄未有 Demo 伺服器。去 Admin 交易伺服器加入 Demo 別名。",
  demoOpenCountry: "國家／地區",
  demoOpenCity: "城市",
  demoOpenState: "州／省",
  demoOpenZip: "郵遞區號",
  demoOpenAddress: "地址",
  bindOkRotated: "已綁定。Investor／master 已按策略處理，密碼只留引擎。",
  bindOkPartial: "已綁定。經紀商未完全允許改密，見下方狀態。",
  bindFailed: "綁定失敗",
  bindWorking: "正在連線經紀商驗證戶口，可能需要數十秒，請稍等…",
  bindPending: "連線成功，已提交綁戶申請，待 Admin 批核。",
  bindQuotaFull: "配額已用完",
  bindQuotaUpgrade: "配額已用完，請升級計劃方案。",
  bindQuotaUpgradePrefix: "配額已用完，請",
  bindQuotaUpgradeLink: "升級計劃方案。",
  bindQuotaDemoHidden: "Demo 配額已用完，別名只顯示 Live 伺服器。",
  bindQuotaLiveHidden: "Live 配額已用完，別名只顯示 Demo 伺服器。",
  bindRequests: "綁戶批核",
  bindRequestsHint: "Live 預設需批核。客戶提交前已試連成功；批准時再連一次並按 bind_rotate_passwords 決定是否改密。",
  approve: "批准",
  approveWorking: "正在再連經紀商完成綁定，可能需要數十秒…",
  approveOk: "已批准，戶口已連線。",
  approveTimeout: "批准仍在後台進行。請稍後刷新待批列表。",
  reject: "拒絕",
  rejectReason: "拒絕原因",
  pending: "待批",
  connectionQuota: "連線配額",
  connectionQuotaDefault: "預設每客連線數",
  demoConnectionQuotaDefault: "預設 Demo 連線數",
  liveConnectionQuotaDefault: "預設 Live 連線數",
  liveBindApproval: "Live 綁戶需批核",
  demoBindApproval: "Demo 綁戶需批核",
  quotaCountsExpiredAccounts: "過期戶口計入連線配額",
  quotaCountsExpiredAccountsHint: "關（預設）：到期日過咗平台日子嘅戶口唔佔配額，客戶可以再綁新 Demo／Live。開：過期戶口仍然佔住配額，要 Admin 解綁先釋放。",
  copyOfferEnabled: "開放跟單申請",
  copyOfferEnabledHint: "即時生效。關：綁定頁唔顯示「申請開放跟單」，下面 Push／消息事件亦即刻收埋。已獲批嘅 Master 仍可開／關跟單。",
  demoTrialDays: "Demo 試用日數",
  riskConsentVersion: "風險條款版本",
  pauseService: "暫停",
  resumeService: "恢復",
  closeAllPositions: "全部平倉",
  stopCloudService: "停止雲端服務",
  servicePaused: "已暫停",
  serviceStopped: "已停止",
  noStrategyRunning: "未啟用策略/跟單",
  copyMasterBadge: "訊源",
  copyFollowBadge: "跟單 · {name}",
  revealAccount: "顯示戶口",
  hideAccount: "隱藏戶口",
  accountCards: "戶口服務卡",
  accountRailPrev: "上一張戶口",
  accountRailNext: "下一張戶口",
  portfolioPerformance: "投資組合表現",
  netEquityDays: "合計權益 · 近 {n} 天",
  netEquityAll: "合計權益 · 所有記錄（{n} 天）",
  accountEquityDays: "戶口權益 · 近 {n} 天",
  accountEquityAll: "戶口權益 · 所有記錄（{n} 天）",
  cashDeposit: "入金",
  cashWithdraw: "出金",
  daysShort: "{n}天",
  equityRangeAll: "所有",
  adminAttention: "需要處理",
  attentionCount: "{n} 項",
  attentionClear: "清閒",
  attentionEmpty: "暫時無需處理嘅事項。",
  attentionBindPending: "綁戶待批",
  attentionCopyOfferPending: "開放跟單待批",
  attentionAccountErrors: "戶口 offline／error",
  attentionDemoExpiring: "Demo 三日內到期",
  attentionStrategyErrors: "策略執行錯誤",
  orgTree: "介紹人樹狀圖",
  webPush: "Web Push 通知",
  webPushHint: "批核、Demo 到期等事件會推送到已安裝嘅 PWA，並同步寫入消息中心俾你回看。同 Telegram Mini App 可以並存。",
  pwaInstallHint: "Chrome：選單 → 安裝 App；iOS Safari：分享 → 加入主畫面。",
  webPushEnable: "開啟推送",
  webPushDisable: "關閉推送",
  webPushOn: "已開啟推送",
  webPushOff: "已關閉推送",
  webPushDenied: "瀏覽器拒絕通知權限",
  webPushNotConfigured: "後台未設定 VAPID 金鑰（VAPID_PUBLIC_KEY / VAPID_PRIVATE_KEY）",
  webPushNeedsHttps: "呢個網址唔係安全環境。Web Push 要 HTTPS，或者本機用 localhost／127.0.0.1。區網 IP（http://192.168.x）收唔到。",
  webPushLocalhostHint: "本機 Chrome／Edge 用 http://localhost 可以收推送，唔使 HTTPS。要喺呢個瀏覽器撳「開啟推送」先會訂閱；只開系統設定事件開關唔夠。Safari 本機 HTTP 唔支援。",
  webPushUnsupported: "呢個瀏覽器唔支援 Web Push。",
  pushEvents: "Push 事件",
  pushEventsHint: "Admin 可開關邊啲事件會發 Web Push／消息中心（綁戶／解綁、批核、Demo、策略開平倉／暫停／停止等）。客戶可喺設定再關細項。",
  savePushEvents: "儲存 Push 事件",
  pushPrefs: "通知偏好",
  pushPrefsHint: "揀邊啲事件寫入鐘仔消息中心，同埋（若已開 Web Push）推去系統通知。策略開／平倉約 30 秒合併一則。",
  pushPrefsSaved: "已更新通知偏好",
  pushPrefAdminOff: "Admin 已關閉呢類事件，暫時唔會推送。",
  pushPrefsLoadFailed: "載入通知偏好失敗。請重新整理，或確認引擎已啟動。",
  messages: "推送消息",
  messagesHint: "系統推送會存喺呢度，未開瀏覽器通知都可以回看。",
  messagesNote: "顯示你帳戶嘅推送消息；清空後可喺歷史數據查看。",
  messagesColTitle: "標題",
  messagesColTime: "創建時間",
  messagesFilterAll: "所有",
  messagesFilterUnread: "未讀",
  messagesFilterRead: "已讀",
  messagesMarkAllRead: "全部標為已讀",
  messagesMarkAllReadDone: "已全部標為已讀",
  messagesClear: "清空",
  messagesPurge: "永久刪除",
  messagesClearTitle: "清空消息匣",
  messagesClearConfirm: "確定清空目前消息匣？清空後可喺「歷史數據」回看；解綁憑證等重要內容建議先複製保存。",
  messagesClearHistoryConfirm: "確定永久刪除全部歷史消息？此操作無法還原。請先自行儲存／複製所有重要資料（例如解綁交返嘅 Server／Login／Master／Investor），刪除後系統唔會再提供。",
  messagesClearHistoryTitle: "永久刪除歷史消息",
  messagesCleared: "已清空",
  messagesPurged: "已永久刪除",
  cancel: "取消",
  messagesHistory: "歷史數據",
  messagesBackInbox: "返回消息匣",
  messagesTotal: "共 {n} 條記錄",
  messagesUnreadCount: "未讀 {n}",
  messagesPageSize: "每頁記錄數",
  messagesPageOf: "/ {n}",
  messagesOpenLink: "前往相關頁面",
  messagesPrev: "上一則",
  messagesNext: "下一則",
  messagesToastView: "查看",
  messagesToastOne: "新消息：{title}",
  messagesToastMany: "新消息：{title}（共 {n} 則未讀）",
  messagesToastFallback: "你有 {n} 則新消息",
  messagesPreviewTitle: "未讀消息",
  messagesPreviewEmpty: "暫無未讀消息",
  messagesGoInbox: "前往消息匣",
  close: "關閉",
  productPlans: "計劃方案",
  productPlansHint: "編輯訂閱卡內容（名、價錢、簡介、亮點、Stripe link）同連線配額；下面可覆寫單一客戶。",
  productPlansStripeLater: "之後會對接 Stripe webhook：自動認訂閱、到期、累計付費等。而家可先貼 Payment Link。",
  planQuotaHint: "方案卡：名字／價錢／簡介／亮點／Stripe link／配額。有改動先出現儲存。",
  assignPlanHint: "指派覆寫：留空＝跟方案預設；填數字＝只對呢個客戶生效（可以比方案更多）。",
  quotaOverride: "覆寫配額",
  unsaved: "未儲存",
  defaultPlanOption: "預設",
  assignPlan: "指派方案",
  setDefaultPlan: "設為預設",
  planEnabled: "開賣／顯示",
  planDisabled: "已關閉",
  planDisabledHint: "已關閉：客戶訂閱頁唔會顯示呢個方案。",
  cannotDisableDefaultPlan: "預設方案唔可以關閉；請先改其他方案做預設。",
  subscribe: "訂閱",
  subscribeHint: "揀付款周期，睇三個方案。Stripe Payment Link 接上之後可直接付款。",
  billingMonthly: "月付",
  billingQuarterly: "季付",
  billingYearly: "年付",
  billingYearlySave: "年付通常更抵",
  perMonth: "/月",
  perQuarter: "/季",
  perYear: "/年",
  currentPlan: "目前方案",
  yourCurrentPlan: "你而家嘅方案",
  choosePlan: "選擇方案",
  stripeLinkPending: "呢個周期嘅 Stripe 付款連結尚未設定，請聯絡 Admin。",
  stripeLinkPendingShort: "即將開放",
  stripeCheckoutOpened: "已開啟付款頁",
  stripeLinkAdminHint: "之後貼 Stripe Payment Link；留空＝客戶見到「即將開放」。",
  planName: "方案名稱",
  planBlurb: "簡介",
  planHighlights: "亮點",
  planHighlightsHint: "每行一點；會顯示喺訂閱卡。",
  planNameRequired: "請填寫繁中方案名稱",
  planPriceInvalid: "請輸入有效價錢（≥ 0）",
  price: "價錢",
  currency: "貨幣",
  strategyExclusions: "策略互斥",
  strategyExclusionsHint: "同一戶口不能同時 enable 互斥策略對。",
  strategyExclusionsEmpty: "尚未設定互斥規則。",
  riskTermsAdmin: "風險條款",
  riskTermsAdminHint: "編輯條款正文與 legal review 備註；activate 會要求客戶重新 consent。",
  riskTermsBody: "條款正文（繁中）",
  legalReviewNote: "Legal review 備註",
  legalReviewedAt: "Legal review 時間",
  activateTerms: "發布／啟用版本",
  yourPlan: "訂閱方案",
  investorMissing: "經紀商未允許改密／尚未輪換",
  hide: "隱藏",
  show: "顯示",
  confirmMasterRotate: "輪換 master 之後舊密碼即時失效，新密碼只留引擎，你睇唔到。繼續？",
  masterRotatedMsg: "Master 已輪換，只留引擎。",
  confirmUnbind: "解綁此戶口？策略同跟單會一併移除。之後會一次過顯示 Server／Login／Master（只此一次），請即刻保存。",
  rotateFailed: "改密失敗",
  copiedInvestor: "已複製 investor",
  slot: "Slot",
  lastSeen: "Last seen",
  noSessions: "未有 session 記錄。",
  sessionTitle: "裝置 session · 1 手機 + 1 桌面",
  now: "目前",
  adminAccountsHint: "頁頂可向經紀商開 Demo 並綁去所選客戶。下面按客戶分組，可發送重設登入密碼郵件。Master／Investor 用密碼欄（眼仔）顯示畀 admin；客戶 API 永遠睇唔到。可直接改 Demo／試用到期日。",
  sendResetEmail: "發送重設郵件",
  confirmSendReset: "向 {email} 發送重設登入密碼連結？客戶喺郵件入面開啟連結再設新密碼。只改 Kairos 門戶密碼。",
  resetEmailSent: "已發送重設郵件到 {email}",
  expandAccountDetails: "展開跟單資訊同到期日",
  collapseAccountDetails: "收起跟單資訊同到期日",
  revealMaster: "顯示 master",
  demoExpiresAt: "到期日",
  clearDemoExpiry: "清空",
  demoExpirySaved: "已更新到期日",
  fetchTradeHistory: "找取交易歷史",
  equityBackfillStarted: "已開始回填 #{login} 歷史，完成後會通知 Admin。",
  equityBackfillRunning: "回填中…",
  confirmUnbindUser: "解綁 {email} #{login}？",
  noBoundAccounts: "尚未有綁定戶口。",
  adminServersHint: "一條伺服器可以有多個 host:port。學生只見到別名；連線時系統會按優先次序自動 failover。MT4／MT5、Demo／Live 都可以用同一個別名。",
  symbolAliases: "跟單品種對照",
  symbolAliasesHint: "ECN 嘅 XAUUSD+ 係後綴，唔好加進 GOLD 組。上面隨時改前／後綴（+、.sc、#）；引擎用呢張表剝名，唔再寫死喺程式。",
  symbolAffixPrefixes: "前綴",
  symbolAffixSuffixes: "後綴",
  symbolAffixPrefix: "前綴，例如 #",
  symbolAffixSuffix: "後綴，例如 +",
  symbolAffixEmpty: "尚未有",
  symbolAffixSaved: "已加入前後綴",
  symbolAffixRemoved: "已移除前後綴",
  symbolAliasGroups: "同義組",
  symbolAliasGroupsHint: "剝完前後綴之後，同一組可以互對（GOLD↔XAUUSD）。跟單戶口同時有兩個對得上嘅名就唔落單。唔好將 BTCUSD 同 BTCUSDT 放同一組，亦唔好將 XAUUSD+ 當別名。",
  symbolAliasCanonical: "標準名",
  symbolAliasExtra: "同義名",
  symbolAliasAdd: "加入",
  symbolAliasAddGroup: "新增一組",
  symbolAliasRemove: "移除",
  symbolAliasDeleteGroup: "刪除此組",
  symbolAliasDeleteGroupConfirm: "刪除「{canonical}」整組別名？跟單之後只靠後綴對品種。",
  symbolAliasSaved: "已加入別名",
  symbolAliasRemoved: "已移除別名",
  symbolAliasEmpty: "尚未有別名組。下面可以加；空表時系統會預填常見指數／黃金。",
  foundServers: "找到 {n} 條伺服器（已按官方名稱合併多個 host）",
  searchFailed: "搜尋失敗",
  importedServer: "已匯入 {name}（{n} 個地址）",
  importFailed: "匯入失敗",
  serverCreated: "已新增伺服器",
  createFailed: "新增失敗",
  pingTesting: "Ping 測試中…",
  pingDone: "Ping 完成",
  pingFailed: "Ping 失敗",
  failed: "失敗",
  enterHostPort: "請先輸入 host:port，例如 mt5-demo.example.com:443",
  officialHidden: "官方名稱（隱藏）",
  endpointsPlaceholder: "多個 host:port，一行一個",
  platform: "平台",
  platformResetHint: "切換 MT4 / MT5 會清空 server login 同 server address，兩邊唔共用。",
  serverLogin: "Server login（官方名稱，ConnectEx）",
  serverAddress: "Server address（host:port，一行一個）",
  badAddress: "地址格式不正確",
  endpointAdded: "已新增 {host}:{port}",
  addEndpointFailed: "新增地址失敗",
  endpointRemoved: "已移除地址",
  removeFailed: "移除失敗",
  confirmDeleteServer: "刪除整條「{alias}」？會一併刪除 {n} 個 host:port。",
  serverDeleted: "已刪除 {alias}",
  deleteFailed: "刪除失敗",
  datParsed: "servers.dat 解析到 {n} 條伺服器，可喺下面匯入",
  uploadFailed: "上傳失敗",
  syncSession: "同步 session…",
  searchResults: "搜尋結果（按官方名稱合併）",
  officialName: "官方名稱",
  endpointCount: "地址數",
  importDemo: "匯入 Demo",
  importLive: "匯入 Live",
  aliasStudent: "別名（學生見到）",
  boundAccounts: "已綁 {n} 戶",
  noOfficial: "無官方名稱",
  serverCompanyUnknown: "未填公司名",
  pingAll: "Ping 全部",
  collapseHosts: "收起",
  expandHosts: "展開",
  invites: "邀請碼",
  invitesHint: "Admin 批次邀請碼。留空代碼會自動產生。客戶 8 位推薦碼都算有效邀請。",
  inviteCodeOptional: "代碼（可留空自動產生）",
  maxUses: "次數上限",
  unlimited: "不限",
  createInvite: "新增邀請碼",
  inviteCreated: "已新增邀請碼",
  inviteNote: "備註",
  deactivate: "停用",
  sourceStrategy: "策略",
  sourceCopy: "跟單 · Kc",
  sourceManual: "人手",
  maxLots: "單筆最多手數",
  dailyMax: "每日最多新倉",
  copyWeight: "跟單比例 %",
  copyFollowingCount: "有 {n} 人跟緊呢個戶口",
  copyFollowingMastersCount: "呢個戶口跟緊 {n} 個 Master",
  copyFollowerLogin: "戶口#",
  copyFollowerEquity: "資金額",
  noCopyFollowers: "尚未有人跟緊呢個戶口。",
  noCopyFollowing: "呢個戶口未有跟人地單。",
  venuesTitle: "場地",
  venuePlanned: "planned",
  venueMt5: "客戶自有經紀商戶口",
  venueMt4: "客戶自有經紀商 MT4 戶口",
  venueBinance: "現貨／永續 adapter 預留",
  venueMexc: "現貨／永續 adapter 預留",
  venueLedger: "充值內賬／任務獎勵預留",
  venuesAdminTitle: "場地",
  venuesAdminHint: "開賣可以新綁。軟關收起綁定、已綁繼續。硬停停策略同跟單新單，唔平倉、權益畫面照更新。場下面伺服器只顯示狀態；改個別經紀商去交易伺服器頁。planned 場即使開賣都唔會接綁戶。",
  venueServerCount: "{n} 部伺服器",
  noBrokers: "呢個場未有經紀商。",
  brokerModeSaved: "經紀商狀態已更新",
  brokerHardStopConfirm: "硬停會停呢隻經紀商上面所有策略同跟單新單，唔會平倉。已綁 {n} 戶。確定？",
  brokerSoftCloseConfirm: "軟關之後客戶唔可以再綁呢隻經紀商；已綁戶口繼續跑。確定？",
  brokerBindClosed: "此經紀商已關閉，暫不接受新綁戶。",
  venueModeOpen: "開賣",
  venueModeSoftClose: "軟關",
  venueModeHardStop: "硬停",
  venueCapabilityLive: "live",
  venueBoundAccounts: "{n} 戶已綁",
  venuePlannedHint: "未接 adapter，開賣都唔會接綁戶。",
  venueHardStopConfirm: "硬停會停呢個場所有策略同跟單新單，唔會平倉。已綁 {n} 戶。確定？",
  venueSoftCloseConfirm: "軟關之後客戶唔可以再綁呢個場；已綁戶口繼續跑。確定？",
  venueModeSaved: "場地狀態已更新",
  venueBindNone: "而家冇開放嘅場地，請稍後再試或聯絡管理員。",
  venueBindClosed: "此場地已關閉，暫不接受新綁戶。",
  venueHardStopClient: "此場地已硬停，策略同跟單暫停代客落單。",
  pinging: "Ping 中…",
  deleteWhole: "刪除整條",
  noEndpoints: "尚未有 host:port，請下面新增。",
  removeEndpoint: "移除地址",
  addEndpoint: "新增地址",
  extraHostPlaceholder: "再加一個 host:port，例如 12.34.56.78:443",
  noServers: "尚未有伺服器。先搜尋或手動新增。",
  brokerPlaceholder: "經紀商名稱，例如 ICMarkets",
  capitalPct: "資金%",
  dateCancel: "取消",
  dateConfirm: "確定",
  dateToday: "今日",
  dateYesterday: "昨日",
  dateThisWeek: "本周",
  dateLastWeek: "上周",
  dateThisMonth: "本月",
  dateLastMonth: "上月",
  dateThisQuarter: "本季度",
  dateLastQuarter: "上季度",
  dateLast7Days: "過去7天",
  dateLast14Days: "過去14天",
  dateAllHistory: "全部歷史",
  dateRangeLabel: "時間範圍",
  tradeAccount: "交易帳號",
  allAccounts: "全部帳號",
  downloadCsv: "下載 CSV",
  filterTitle: "篩選",
  filterAddFields: "添加篩選欄位",
  filterReset: "重置",
  filterQuery: "查詢",
  filterAvailable: "可選欄位",
  filterSelected: "已選欄位",
  filterSelectAll: "選擇全部",
  filterSearchField: "搜尋欄位",
  filterActiveCount: "{n}項",
  filterCommand: "指令",
};

const zhHans: Dict = {
  ...zhHant,
  tagline: "机构级交易作业系统",
  subtitle: "客户自有账户 · 系统代为执行 · 同一套引擎通往 MT5 与交易所",
  login: "登录",
  register: "开户",
  logout: "登出",
  dashboard: "控制台",
  admin: "管理后台",
  servers: "交易服务器",
  accounts: "交易账户",
  strategies: "策略",
  copy: "跟单",
  referral: "介绍人",
  unbind: "解绑",
  allowCopy: "开放跟单",
  applyCopyOffer: "申请开放跟单",
  editCopyOffer: "编辑名称／简介",
  copyOfferTitle: "策略名称",
  copyOfferDescription: "简单描述",
  copyOfferSubmit: "提交申请",
  copyOfferPending: "申请开放跟单待批中",
  copyOfferRejected: "开放跟单申请被拒",
  copyOfferApprovedHint: "已获批开放跟单权，可自行开／关。改名称／简介即时生效。",
  copyOfferWorking: "正在提交申请…",
  copyOfferSaving: "正在保存…",
  copyOfferOk: "已提交开放跟单申请，待 Admin 批核。",
  copyOfferUpdated: "已更新跟单名称／简介。",
  copyOfferApproveOk: "已批准开放跟单",
  copyOfferRejectOk: "已拒绝开放跟单申请",
  copyOfferRejectConfirm: "拒绝 {email} #{login} 的开放跟单申请？",
  revokeCopyOffer: "收回跟单权",
  revokeCopyOfferConfirm: "收回 {email} #{login} 的开放跟单权？客户要重新申请才可以再开。",
  revokeCopyOfferOk: "已收回跟单权",
  copyOfferNeedApproved: "尚未获批开放跟单权，请先申请",
  needOnlineForCopy: "账户要先连上 MT5，才可以转成 master。",
  copyFollowersBlockOff: "仍有 {n} 位客户跟单此账户，对方取消跟单后才可关闭「开放跟单」。",
  copyFollowersBlockUnbind: "仍有 {n} 位客户跟单此账户，对方取消跟单后才可关闭跟单再解绑。",
  unbindNeedDisableCopy: "请先关闭「开放跟单」再解绑。",
  unbindConsentTitle: "解绑账户确认与服务终止说明",
  unbindConsentVersion: "v1",
  unbindConsentAgree: "我已阅读并同意上述解绑说明。",
  unbindConsentConfirm: "同意并解绑",
  unbindConsentBody:
    "1. 解绑将终止 Kairos 对此交易账户的执行与策略／跟单托管服务；平台不代管您的资金，资金仍存放于您选择的经纪商账户。\n" +
    "2. 解绑后，此账户上已启用的策略分配和跟单链接将一并移除或停用；系统不会继续代您开仓、平仓或跟单。\n" +
    "3. 解绑成功后，系统会一次性向您交还 Server name（经纪商）、Login 和 Master 密码（仅此一次／并写入消息中心）。请立刻自行妥善保存；之后平台不保证可再显示完整明文凭证。\n" +
    "4. 您有责任在解绑后自行管理该经纪商账户、密码与风险；若凭证遗失、遭第三方使用或经纪商拒绝连线，后果由您自行承担。\n" +
    "5. 解绑不等于经纪商销户，亦不保证可即时重新绑定；重新绑定可能受场地开关、配额、审批政策、账户状态或系统维护影响。\n" +
    "6. 若此账户仍开放跟单，或仍有其他客户跟单，您必须先待跟单者取消跟单并关闭「开放跟单」，才可以解绑。\n" +
    "7. 您确认已阅读并理解上述说明，同意终止本账户在 Kairos 的绑定与相关服务。",
  investor: "投资者密码",
  bind: "绑定账户",
  email: "电邮",
  password: "密码",
  showPassword: "显示密码",
  hidePassword: "隐藏密码",
  invite: "邀请码",
  invitePlaceholder: "KAIROS-2026 或 8 位推荐码",
  code: "验证码",
  verify: "验证电邮",
  locale: "语言",
  equity: "权益",
  balance: "余额",
  credit: "信用额",
  positions: "持仓",
  status: "状态",
  alias: "别名",
  search: "搜索经纪商",
  import: "导入",
  manual: "手动新增",
  save: "保存",
  enabled: "启用",
  demo: "模拟",
  live: "真实",
  host: "主机",
  port: "端口",
  official: "官方名称（学生不可见）",
  company: "公司",
  actions: "操作",
  mtLogin: "MT5 账号",
  accountShort: "账号",
  masterPassword: "主密码",
  studentHint: "学生只会看到别名，不会看到真实服务器地址。",
  fetchMt5: "用 mt5rest 搜索",
  fetchMt4: "用 mt4rest 搜索",
  uploadDat: "上传 servers.dat",
  uploadSrv: "上传 .srv / servers.ini",
  requireInvite: "注册必须邀请码",
  socialLogin: "社交登录",
  socialLoginHint: ".env 填齐之后，还要在这里打开才会在登录／开户页出按钮。关了连 API 都拒。",
  googleLoginEnabled: "允许 Google 登录／开户",
  telegramLoginEnabled: "允许 Telegram 登录／开户",
  googleEnvReady: ".env 已填 Google Client。",
  googleEnvMissing: "未填 GOOGLE_CLIENT_ID／SECRET，开了也还不能用。",
  telegramEnvReady: ".env 已填 Telegram Bot。",
  telegramEnvMissing: "未填 TELEGRAM_BOT_TOKEN／USERNAME，开了也还不能用。",
  adminSettings: "系统设置",
  adminSettingsHint: "全系统 config。改完点页底保存一次性写入。闪动秒数套用所有用户；每人仍可在自己设置关闭效果。",
  loadFailed: "加载失败",
  saving: "保存中…",
  connectionQuotaInvalid: "请输入 1 至 100 之间的连线数",
  demoTrialInvalid: "请输入 0 至 365 之间的天数",
  riskConsentVersionInvalid: "请填写风险条款版本",
  adminStrategies: "策略产品",
  adminStrategiesHint: "开卖、客户卡露出哪些参数、catalog 默认、哪些户在跑。关产品不会自动平仓；改默认不会覆盖现有户口。",
  catalogOpen: "开卖",
  catalogClosed: "软关",
  catalogUnavailable: "这条策略暂时未向客户开放。",
  clientSurface: "客户表面",
  clientSurfaceHint: "点表面循环：常用 → 进阶 → 锁定 → 隐藏。↑↓ 改顺序。保存才生效。",
  surfaceSimple: "常用",
  surfaceAdvanced: "进阶",
  surfaceLocked: "锁定",
  surfaceHidden: "隐藏",
  liveBook: "Live book",
  liveBookHint: "不显示真实 host／master。参数列只显示与 catalog 不同的 key。",
  openProduct: "打开",
  softCloseHint: "关卖之后客户目录不再出现；已跑户口继续，直到自己停或你硬停。",
  softCloseConfirm: "现在有 {n} 个户口在跑。软关只是不再卖给新客户，不会停他们。确定？",
  softCloseActive: "软关中：{n} 个户口仍在跑。",
  hardStop: "硬停全部运行中",
  hardStopHint: "只停策略，不自动平仓。",
  hardStopConfirm: "将 {name} 的 {n} 个运行中户口停掉（不平仓）。确定？",
  hardStopDone: "已停 {n} 个户口。",
  catalogDefault: "默认值",
  defaultsNotLive: "改默认只影响新启用和客户点重设；现有 allocation 不会被覆盖。",
  followCatalog: "跟 catalog",
  noLiveAllocations: "尚未有户口配置这条策略。",
  advancedParams: "进阶参数",
  schemaSaved: "已保存产品设置。",
  paramKey: "参数",
  clientPreview: "客户卡预览",
  vsCatalog: "相对 catalog",
  strategyNameField: "策略名称",
  strategyBlurbField: "简介说明",
  strategyCopyHint: "客户策略卡显示的名称和介绍。跟系统语言列表自动出栏；slug 不能改。",
  editStrategyCopy: "编辑名称／简介",
  collapseStrategyCopy: "收起名称／简介",
  nameZhHant: "名称 · 繁中",
  nameZhHans: "名称 · 简中",
  nameEn: "Name · EN",
  blurbZhHant: "简介 · 繁中",
  blurbZhHans: "简介 · 简中",
  blurbEn: "Blurb · EN",
  brokerLogs: "经纪商指令",
  brokerLogsJournal: "指令记录",
  brokerLogsHint: "引擎打去 mt4rest／mt5rest 的指令和回传。每行会记哪一页／哪个功能打出来。密码和 Connect URL 不会写入。Worker keep-alive 不写入数据库；报价默认收起。",
  brokerLogsChatter: "显示报价／keep-alive",
  brokerLogsQuery: "搜索 command／送出／回传／失败",
  brokerLogsHours: "时间范围",
  brokerErrorsOnly: "只看失败",
  brokerCallerPage: "来源页",
  brokerCallerFeature: "功能",
  brokerCaller: "来源",
  brokerClearFilters: "清除所有筛选",
  brokerShowingCount: "显示 {n} 笔",
  brokerRest: "REST 探查",
  brokerRestHint: "用人手打 mt4rest／mt5rest 读取。浏览器不直连经纪商；写入、改密、Connect 不开放。列表回传用表格显示，方便对「拿错／拿不到」。",
  brokerRestAccount: "已绑户口",
  brokerRestSend: "发送",
  brokerRestNeedAccount: "这个指令要用引擎现有的户口连线，请先选已绑户口。",
  brokerRestTable: "表格",
  brokerRestJson: "JSON",
  brokerRestRows: "{n} 列",
  brokerRestGroupServer: "服务器",
  brokerRestGroupAccount: "账户",
  brokerRestGroupPositions: "持仓",
  brokerRestGroupHistory: "历史",
  brokerRestGroupQuotes: "报价",
  brokerRestPickCommand: "选一个指令",
  brokerRestSending: "发送中…",
  brokerRestEmpty: "未有回传。选指令之后按发送。",
  last1h: "过去 1 小时",
  last6h: "过去 6 小时",
  last24h: "过去 24 小时",
  last7d: "过去 7 天",
  allPlatforms: "全部平台",
  allCommands: "全部指令",
  resultOk: "成功",
  resultError: "失败",
  durationMs: "耗时",
  requestBody: "送出",
  responseBody: "回传",
  tickFlashSeconds: "数字闪动秒数",
  tickFlashSecondsHint: "权益／盈亏变动时背景闪动多久（0.15–3 秒）。Config key：tick_flash_seconds",
  tickFlashSecondsInvalid: "请输入 0.15 至 3 之间的秒数",
  tickFlashEnabled: "数字闪动效果",
  tickFlashEnabledHint: "只影响你自己。Config key：tick_flash_enabled",
  seconds: "秒",
  minutes: "分钟",
  idleTimeoutHint: "键盘鼠标无操作多久之后自动登出。0 = 不超时。Config key：idle_timeout_seconds（默认 5 分钟）",
  idleTimeoutInvalid: "请输入 0 或以上的分钟数",
  idleLoggedOut: "已超过无操作时间，请重新登录。",
  brokerLogRetentionHint: "经纪商指令 log 在数据库留多久。0 = 不删。Config key：broker_log_retention_days（默认 7 天）",
  brokerLogRetentionInvalid: "请输入 0 至 365 之间的天数",
  days: "天",
  hours: "小时",
  passwordRotateHoursHint: "自动轮换 investor／master 的间距（小时）。0 = 不自动。Config：investor_rotate_hours／master_rotate_hours；环境变量 INVESTOR_ROTATE_HOURS／MASTER_ROTATE_HOURS（默认 12）",
  passwordRotateHoursInvalid: "请输入 0 至 8760 之间的小时数",
  bindRotatePasswords: "绑户时改密（investor + master）",
  bindRotatePasswordsHint: "开：连线成功后改 investor 并轮换 master，成功才写 DB。关：跳过改密，直接用客户输入的 master 存 DB。绑定期间客户看不到 MT 密码；解绑才一次性交还。Config：bind_rotate_passwords；环境变量 BIND_ROTATE_PASSWORDS（默认关）",
  sessionKicked: "已在另一台电脑登录，这里已被踢出。",
  empty: "暂无数据",
  connectOk: "已连接",
  connectFail: "连接失败",
  googleSoon: "Google 登录稍后开放",
  home: "主页",
  portfolio: "仓位",
  tasks: "任务",
  settings: "设置",
  floating: "浮动盈亏",
  winRate: "持仓胜率",
  trades: "交易次数",
  followers: "跟单人数",
  following: "正在跟",
  quotes: "报价",
  running: "运行中",
  stopped: "未启用",
  hedge: "对冲模式 · 同品种可同时 BUY + SELL",
  reward: "奖励",
  planned: "金流未接 · 完成度已即时计算",
  sessions: "装置 session",
  currentDevice: "当前装置",
  copyCode: "复制",
  liveProof: "Demo / Live 同一条绑定路径，只换服务器别名",
  pwdOk: "密码策略已套用",
  pwdInvestorOk: "Investor 已套用",
  pwdInvestorDenied: "Investor 改密被拒",
  pwdMasterDenied: "Master 轮换被拒",
  pwdDenied: "经纪商禁用改密",
  pwdPending: "尚未轮换",
  pwdSkipped: "绑户未改密（设定关闭）",
  bindOkSkipped: "已绑定。未改密，沿用你输入的 master（只留引擎）。",
  boundNoMtPasswordsHint: "绑定期间不显示 master／investor；仓位和平仓在 Kairos 处理。解绑时会一次性交还 Server／Login／Master。",
  unbindHandoffTitle: "解绑完成 · 请立刻保存凭证",
  unbindHandoffOnce: "请立刻复制保存。完整凭证亦已存入顶栏铃铛「推送消息」，之后可回看。",
  unbindServerName: "Server name（经纪商）",
  unbindLogin: "Login",
  unbindMaster: "Master",
  unbindInvestor: "Investor",
  unbindInvestorMissing: "此账户没有 investor（绑户时可能跳过了改密）。",
  unbindHandoffSaved: "我已保存",
  unbindFailed: "解绑失败",
  copied: "已复制",
  rotateInvestor: "轮换 investor",
  rotateMaster: "轮换 master",
  copyInvestor: "复制 investor",
  masterInEngine: "Master 只留引擎",
  loading: "载入中…",
  pleaseLogin: "请先登录。",
  needAdmin: "需要管理员权限。",
  expandSidebar: "开启侧栏",
  collapseSidebar: "关闭侧栏",
  language: "语言",
  accountsMenu: "户口",
  navExecute: "执行",
  navGrowth: "增长",
  darkMode: "深色模式",
  roleClient: "客户",
  roleAdmin: "管理员",
  referralCode: "推荐码",
  avatar: "头像",
  avatarHint: "选一个预设头像，会显示在顶栏和菜单。",
  avatarAdminFixed: "管理员使用专用头像，不用选择。",
  changeAvatar: "更换头像",
  marketsLive: "市场开市",
  connecting: "连接中…",
  loginTitle: "登录控制面",
  loginHint: "同一套 session 行门户、引擎和 MT5 桥。密码不会经过浏览器直打经纪商。",
  loginFailed: "登录失败",
  noAccount: "没有账户？",
  forgotPassword: "忘记密码",
  forgotTitle: "重设登录密码",
  forgotHint: "只重设 Kairos 门户密码，不会改经纪商 Master／Investor。输入已验证电邮，我们会寄重设链接。",
  forgotSent: "如果此电邮已注册，我们已寄出重设链接。链接 10 分钟内有效。",
  forgotCheckTitle: "请检查你的电邮",
  forgotCheckBody: "如果 {email} 已注册，收件箱会有重设链接（10 分钟内有效）。",
  sendResetLink: "发送重设链接",
  resetHint: "设置新的 Kairos 登录密码。不会改经纪商 Master／Investor。",
  resetInvalid: "重设链接无效或已过期。请重新申请。",
  devResetLink: "开发模式重设链接：{link}",
  orDivider: "或",
  resetPassword: "重设密码",
  newPassword: "新密码",
  confirmPassword: "确认新密码",
  passwordMismatch: "两次密码不一致",
  resetOk: "密码已重设，请用新密码登录。",
  backToLogin: "返回登录",
  signInWithGoogle: "使用 Google 登录",
  signInWithTelegram: "使用 Telegram 登录",
  oauthNotConfigured: "未设置此登录方式。填好引擎环境变量后重启即可。",
  oauthInviteHint: "新账户若需邀请码，请先填写再点 Google／Telegram。",
  registerInviteHint: "电邮开户与 Google／Telegram 共用这个邀请码。",
  emailRegister: "用电邮开户",
  errGoogleDisabled: "Google 登录尚未设置。",
  errGoogleDenied: "已取消 Google 授权。",
  errGoogleNoEmail: "Google 账户没有电邮。",
  errInviteRequired: "新账户需要邀请码。请填写邀请码后再点登录。",
  errOauthConflict: "此社交账户已绑其他用户。",
  errGoogleFailed: "Google 登录失败。",
  registerHint: "验证电邮为繁中／简中／英文对照。系统会记住你的语言。",
  registerFailed: "注册失败",
  verifyFailed: "验证失败",
  sendCode: "发送验证码",
  finishVerify: "完成验证",
  codeSent: "验证码已发到 {email}",
  devCode: "开发模式验证码：{code}",
  hasAccount: "已有账户？",
  landingTitle: "机构级交易作业系统",
  landingBody: "钱留在客户自己经纪商。Kairos 只负责连线、风控、策略和下单。同一套控制台之后可以接到交易所。",
  enterSystem: "进入系统",
  haveAccount: "已有账户",
  pillar1: "多租户门户、邀请码、双设备 session，学生只见服务器别名。",
  pillar2: "自建 MT5 REST。Demo / Live 只换 access 列表，不换引擎。",
  pillar3: "每户 keep-alive、持仓同步、多策略与跟单预位。",
  pillar4: "同一控制面预留交易所 API 与平台内账，评审见到的是一套系统。",
  nonCustodialBody: "Master password 只由系统交易。学生见到别名和 investor 视图，不会见到真实 server 名。",
  homeHint: "权益、仓、跟单人数由引擎同步。浏览器只打 Kairos API，不直连经纪商。",
  accountDisabled: "已停用",
  copyPaused: "跟单已暂停",
  accountExpired: "已到期",
  accountBrokerDisabled: "经纪商已停用或过期此账户，引擎已停止重连。请到绑定页解绑后改绑新户。",
  accountDemoExpired: "Demo 试用已到期，引擎已停止连线。",
  accountsLabel: "账户",
  connection: "连线",
  miniBlotter: "迷你 blotter",
  allPositions: "全部仓位",
  blotterAccount: "户",
  symbol: "品种",
  side: "方向",
  pnl: "盈亏",
  noPositionsHint: "暂无持仓。去策略页启用均线突破，或跟一个 Master。",
  goBind: "去绑定",
  bindNav: "绑定",
  noAccountsYet: "尚未绑户。",
  allBoundEquity: "所有绑定户合计",
  openCountHint: "{n} 张持仓",
  openWinHint: "开仓中盈利张数",
  engineFills: "引擎已送出的单",
  followingMasters: "正在跟 {n} 个 master",
  portfolioHint: "持仓与资金由引擎 keep-alive 同步。点户口卡看该户 blotter。",
  portfolioExpiredTitle: "户口连接权限已到期",
  portfolioExpiredHint: "此户口连接系统的权限已到期，引擎已停止连线。如场上仍有订单，请到经纪商自行处理。",
  noAccountsBind: "尚未绑户。去「户口 → 绑定」绑 MT5／MT4。",
  blotter: "持仓 blotter",
  blotterCountLive: "{live} 持仓",
  blotterCountSplit: "{n} 张单，{live} 持仓，{pending} 挂单",
  lots: "手数",
  openPrice: "开仓价",
  currentPrice: "现价",
  stopLoss: "止损",
  takeProfit: "止盈",
  action: "操作",
  source: "来源",
  openTime: "开仓时间",
  closePosition: "平仓",
  closeThisTicket: "平仓",
  closeThisTicketConfirm: "确定平这张 {symbol} #{ticket}？",
  closeThisTicketDone: "已送出平仓。",
  deletePendingOrder: "删除",
  deletePendingOrderConfirm: "确定删除 {symbol} #{ticket} 这张挂单？",
  deletePendingOrderDone: "已删除挂单。",
  noPositionsHedge: "暂无持仓。同品种可同时 BUY + SELL（对冲）。",
  blotterNote: "现价用该户报价（多单 bid、空单 ask）。盈亏是浮动，以经纪商账户为准。",
  sectionCollapse: "收起",
  sectionExpand: "展开",
  batchOps: "批量操作",
  batchGroupCount: "{n} 组",
  batchTotalTickets: "总单量",
  batchTotalLots: "总手数",
  batchTotalPnl: "总盈亏",
  batchWinTotal: "浮盈单总计",
  batchLossTotal: "浮亏单总计",
  batchLegSummary: "{n} 张 共 {lots} 手",
  batchCloseWin: "只平浮盈",
  batchCloseLoss: "只平浮亏",
  batchCloseAll: "全部平仓",
  batchCloseWinConfirm: "确定平掉 {symbol} {side} 的 {n} 张盈利单（共 {lots} 手）？",
  batchCloseLossConfirm: "确定平掉 {symbol} {side} 的 {n} 张亏损单（共 {lots} 手）？",
  batchCloseAllConfirm: "确定平掉 {symbol} {side} 全部 {n} 张（共 {lots} 手）？",
  batchCloseDone: "已送出 {n} 张平仓。",
  batchClosePartialFailed: "{n} 张平仓失败。",
  batchEmpty: "暂无可批量平仓的持仓（挂单不计）。",
  priceCandles: "价格 K 线",
  priceCandlesHint: "中间拖左右/上下平移；右边价位刻度上拉放大、下拉缩细 K 线；timeline 拖右放大、拖左缩细；手机双指左右 pinch 时间、上下 pinch 价位（双击重置）。持仓开仓价离开可见 bar 仍显示横线和左 label；hover/click bar 左上角明细卡。",
  priceCandlesTipOpen: "开仓",
  priceCandlesTipClose: "平仓",
  priceCandlesPinned: "已固定",
  priceCandlesUnpin: "取消固定",
  priceCandlesClickPin: "Click 固定",
  priceCandlesDragPanel: "拖动面板",
  priceCandlesCollapsePanel: "收起控制面板",
  priceCandlesExpandPanel: "展开控制面板",
  priceCandlesLoadFailed: "图表暂时读不到。",
  priceCandlesLoadOlder: "加载更旧 K 线",
  priceCandlesLoadOlderBusy: "加载更旧 K 线中…",
  priceCandlesLoadOlderOk: "已加入 {n} 根 K 线 · 最早 {time}",
  priceCandlesLoadOlderEmpty: "Broker 无更旧 K 线",
  priceCandlesLoadOlderFailed: "加载失败：{error}",
  priceCandlesLive: "LIVE",
  priceCandlesNow: "现在",
  priceCandlesLiveOrders: "持仓",
  priceCandlesHistoryToggle: "平仓记录天数",
  priceCandlesHistoryAllHint: "all 最多显示 500 笔平仓",
  priceCandlesHistoryBusy: "加载平仓记录中…",
  priceCandlesHistoryOk: "已加载 {n} 笔平仓记录",
  priceCandlesHistoryEmpty: "这段时间无平仓记录",
  priceCandlesHistoryFailed: "平仓记录加载失败：{error}",
  pendingStop: "Stop",
  pendingLimit: "Limit",
  pendingStopLimit: "Stop Limit",
  quotesAfterPositions: "暂无报价。这个户口暂时没有持仓品种。",
  floatingShort: "浮动",
  allocationHint: "同一账户可同时跑多条策略，各自 magic／comment，仓位互不相平。第一条用来打通开平仓。",
  bindFirst: "请先在「户口 → 绑定」绑定账户。",
  maBreakout: "均线突破",
  maBreakoutBlurb: "Fast MA 上穿 Slow MA 开多，下穿开空。用来证明引擎真的开得到、平得到，不是回测图。",
  xauHedge: "黄金对冲网格",
  xauHedgeBlurb: "随机开第一张金仓。顺势走满距离就同向加仓并把整篮 SL 锁在打和价＋赚点；逆势就反向对冲，两条价位线上严格交替加仓（Fibonacci 手数），打和＋trailing 一次过全平，冷却再开新局。MT4／MT5 hedge。",
  stepPoints: "距离（点）",
  profitPoints: "赚几点",
  volumeMult: "第2張倍率（其後 Fibonacci）",
  cooldownSec: "冷却秒",
  trailPct: "Trailing %",
  maxLevels: "单局最多层",
  forceBeSl: "强制打和SL价位",
  forceBeSlHint: "关：Path A 有新成交票才改一次经纪商 SL。开：发现票面 SL 与计算值不同时才改。",
  magicCommentHint: "下单标记。引擎用 magic 或 comment 开头认仓。magic 可以是 0（此时只靠 comment 认仓，不要同人手单撞）。不要跟跟单 Kc 撞；改之前请平掉用旧标记的单。",
  roundPhase: "本局",
  moreStrategies: "更多策略",
  moreStrategiesHint: "allocation book 已预位。下一条策略只加定义 + worker 分支，不用改门户结构。",
  updateParams: "更新参数",
  assignAccount: "配置到此户",
  paramsHint: "停止后先改参数，再点配置到此户写入引擎。转户口会丢弃未配置的改动。",
  stopToEdit: "运行中不能改参数。请先停止。",
  insufficientCapital: "权益不足：需要 {need}，现在 {have}",
  capitalRequiredHint: "启用时户口权益要达标。",
  symbolRequired: "请填写品种。",
  paramsSaved: "已写入此户并开始运行。",
  stop: "停止",
  positionDetails: "持仓明细",
  positionTicketCount: "{n}张",
  positionSummaryLine: "{n}张 · {lots}手",
  hedgePnlNote: "本策略同时持有买卖对冲，单边损益会互相抵销；实际风险看净浮盈与期间损益。",
  noStrategyPositions: "这条策略暂无持仓。",
  pauseTrading: "暂停交易",
  resumeTrading: "恢复交易",
  tradePausedHint: "已暂停下单；持仓仍会显示，可一键平仓。",
  tradePausedBadge: "已暂停下单",
  closeStrategyPositions: "一键平仓",
  closeStrategyPositionsConfirm: "确定平仓以下这条策略的持仓？不会平其他策略或人手单。",
  closeStrategyConfirmAction: "确定平仓",
  closeStrategyWorking: "平仓中，请稍候…",
  closeStrategyResultTitle: "平仓结果",
  closeStrategyClosedCount: "已平 / 请求",
  closeStrategyFailedCount: "失败",
  closeStrategyLotsLabel: "已平手数",
  closeStrategyProfitLabel: "浮盈（平仓前）",
  closeStrategyLotsSum: "{lots}手",
  closeStrategyProfitSum: "浮盈 {pnl}",
  closeStrategyItemOk: "已平",
  closeStrategyItemFail: "失败",
  closeStrategyDone: "完成",
  strategyPositionsClosed: "已平仓这条策略的持仓。",
  tradingPaused: "已暂停这条策略下单。",
  tradingResumed: "已恢复这条策略下单。",
  resetParams: "重设",
  stoppedKeepParams: "已停止此户策略，参数保留。",
  paramsReset: "已还原策略默认值（只改画面）。要写入引擎先点配置到此户；转户口会丢弃未配置的改动。",
  saveFailed: "保存失败",
  copyHint: "一个 follower 可跟多个 master。同品种可同时 BUY+SELL，不会合成一张。只跟原创仓，不跟已经是 copy 的单。",
  followWith: "用 #{login} 去跟",
  copyFollowerAccount: "跟单账户",
  copyDefaultWeight: "默认比例 %",
  copyControlHint: "下面「我的跟单／复制持仓／跟单动态」都跟这个账户。",
  copyMasterTag: "(Master)",
  copyNoFollowerAccounts: "没有可用的跟单账户。已开放跟单的 Master 账户不能再去跟其他人。",
  copyMasterCannotFollow: "已开放跟单的 Master 账户不能用来跟其他人。",
  hedgeMode: "对冲模式",
  teamMaster: "团队 Master",
  followingNow: "跟紧",
  followMasterPct: "跟此 Master",
  noMasters: "尚未有开放跟单的 Master。客户要申请并经 Admin 批核后，才可以在绑定页开放跟单。",
  copyMarket: "信号市集",
  myCopies: "我的跟单",
  myCopiesEmpty: "这个账户尚未跟任何 Master。可在上面信号市集选一个跟。",
  copyBook: "复制持仓",
  copyBookCount: "{n} 张",
  copyFloating: "浮盈",
  copyActivity: "跟单动态",
  copyActivityHint: "系统代这个账户跟单的近期开仓。",
  copyRelations: "跟单关系 / 已复制仓",
  copyFills: "引擎跟单开仓记录",
  noFills: "尚未有跟单开仓。",
  updateWeight: "更新比例",
  noCopied: "这个账户暂时没有复制持仓。",
  stopCopy: "停止跟单",
  stopCopyConfirm: "停止跟「{name}」？之后不会再抄这个 Master 的新仓；已有复制仓不会自动平仓。",
  stopCopyOk: "已停止跟单",
  copyFailed: "跟单失败",
  referralHint: "推荐码可当注册邀请码，8 个英数字，可自订。佣金和兑 USDT 之后接 internal_ledger。",
  customCode: "自订推荐码",
  customCodeHint: "必须刚好 8 个英文字母或数字，大小写不计。",
  saveCode: "保存推荐码",
  referrer: "介绍人",
  noReferrer: "未有介绍人",
  setReferrer: "改介绍人",
  unlinkReferrer: "解除连结",
  adminReferralsHint: "改客户和介绍人的关系。用对方 8 位推荐码连结，不会形成循环。",
  referrerCode: "介绍人推荐码",
  cycleBlocked: "会形成循环介绍",
  linkUpdated: "已更新介绍关系",
  cannotReferSelf: "不能自己介绍自己",
  invitedBy: "介绍人",
  inviteeCount: "已邀请人数",
  invited: "已邀请",
  nextStep: "下一步",
  taskCenter: "任务中心",
  goComplete: "去完成",
  copyReferral: "复制推荐码",
  copied: "已复制",
  inviteList: "邀请名单",
  time: "时间",
  noInvitees: "尚未有人用你的码注册。",
  taskHint: "完成度即时计算。USDT 兑换标 planned——等平台内账，不要当已出金。",
  completed: "已完成",
  accruedUsdt: "应计 USDT",
  unsettled: "未结算",
  done: "完成",
  notDone: "未完成",
  rewardUsdt: "奖励 {n} USDT",
  ledgerUnwired: "（未接金流）",
  settingsHint: "语言在左下角随时切。绑户／解绑去「户口 → 绑定」。",
  passwordSection: "登录密码",
  passwordSectionHint: "更改 Kairos 登录密码。其他装置会被登出。不影响经纪商密码。",
  setPasswordHint: "此账户现在用 Google／Telegram 登录。设定密码之后可以用电邮登录。",
  currentPassword: "目前密码",
  changePassword: "更改密码",
  setPassword: "设定密码",
  passwordChanged: "密码已更新。",
  linkedLogins: "社交账户",
  linkedLoginsHint: "用电邮密码登录之后，可以在这里绑定或解绑 Google／Telegram。解绑不会删账户。",
  bindGoogle: "绑定 Google",
  bindTelegram: "绑定 Telegram",
  unbindGoogle: "解绑 Google",
  unbindTelegram: "解绑 Telegram",
  googleLinked: "已绑定",
  telegramLinked: "已绑定",
  notLinked: "未绑定",
  linkedOk: "已绑定。",
  unlinkedOk: "已解绑。",
  confirmUnlinkGoogle: "解绑 Google？之后要用邮箱密码或 Telegram 登录。",
  confirmUnlinkTelegram: "解绑 Telegram？之后要用邮箱密码或 Google 登录。",
  telegramDomainHint: "Telegram 小工具需要 BotFather 已登记的 HTTPS 域名；localhost 会显示 Bot domain invalid。",
  bindMt5: "Bind MT5 · DEMO / LIVE",
  bindMt4: "Bind MT4 · DEMO / LIVE",
  bindHint: "选别名，不用填 host。需批核的环境会先试连，成功才交 Admin。绑定期间不显示 MT 密码；解绑时一次性交还。",
  demoOpenTitle: "开 Demo（Admin）",
  demoOpenHint: "向经纪商申请 Demo，绑到下面选的客户（默认你自己）。浏览器不直连 REST。不支持的经纪商会失败，请去官网开再用客户绑定页表单绑。服务器列表不会因为你自己配额满而消失。",
  demoOpenBindTo: "绑到客户",
  demoOpenBindSelf: "当前",
  demoOpenQuotaFull: "所选客户 Demo 配额已满。换另一个客户，或去计划方案加配额。",
  demoOpenSubmit: "开 Demo 并绑定",
  demoOpenWorking: "正在向经纪商申请 Demo，可能需要一分钟…",
  demoOpenOk: "已开 Demo 并绑定。",
  demoOpenUnsupported: "这家经纪商不接受终端／API 开 Demo。请去官网开，再用客户绑定页表单绑。",
  demoOpenConnectFailed: "Demo 已开但连线失败。请复制 Login／Master，用客户绑定页表单绑，或在 MT 终端登录。",
  demoOpenHandoffTitle: "Demo 已开 · 请保存凭证",
  demoOpenAdvanced: "进阶",
  demoOpenDeposit: "入金",
  demoOpenLeverage: "杠杆",
  demoOpenName: "姓名",
  demoOpenPhone: "电话",
  demoOpenNoServers: "目录没有 Demo 服务器。请到 Admin 交易服务器加入 Demo 别名。",
  demoOpenCountry: "国家／地区",
  demoOpenCity: "城市",
  demoOpenState: "州／省",
  demoOpenZip: "邮递区号",
  demoOpenAddress: "地址",
  bindOkRotated: "已绑定。Investor／master 已按策略处理，密码只留引擎。",
  bindOkPartial: "已绑定。经纪商未完全允许改密，见下方状态。",
  bindFailed: "绑定失败",
  bindWorking: "正在连线经纪商验证户口，可能需要数十秒，请稍等…",
  bindPending: "连线成功，已提交绑户申请，待 Admin 批核。",
  bindQuotaFull: "配额已用完",
  bindQuotaUpgrade: "配额已用完，请升级计划方案。",
  bindQuotaUpgradePrefix: "配额已用完，请",
  bindQuotaUpgradeLink: "升级计划方案。",
  bindQuotaDemoHidden: "Demo 配额已用完，别名只显示 Live 服务器。",
  bindQuotaLiveHidden: "Live 配额已用完，别名只显示 Demo 服务器。",
  bindRequests: "绑户批核",
  bindRequestsHint: "Live 默认需批核。客户提交前已试连成功；批准时再连一次并按 bind_rotate_passwords 决定是否改密。",
  approve: "批准",
  approveWorking: "正在再连经纪商完成绑定，可能需要数十秒…",
  approveOk: "已批准，户口已连线。",
  approveTimeout: "批准仍在后台进行。请稍后刷新待批列表。",
  reject: "拒绝",
  rejectReason: "拒绝原因",
  pending: "待批",
  connectionQuota: "连线配额",
  connectionQuotaDefault: "默认每客连线数",
  demoConnectionQuotaDefault: "默认 Demo 连线数",
  liveConnectionQuotaDefault: "默认 Live 连线数",
  liveBindApproval: "Live 绑户需批核",
  demoBindApproval: "Demo 绑户需批核",
  quotaCountsExpiredAccounts: "过期户口计入连线配额",
  quotaCountsExpiredAccountsHint: "关（默认）：到期日过了平台日期的户口不占配额，客户可以再绑新 Demo／Live。开：过期户口仍然占住配额，要 Admin 解绑才释放。",
  copyOfferEnabled: "开放跟单申请",
  copyOfferEnabledHint: "即时生效。关：绑定页不显示「申请开放跟单」，下面 Push／消息事件也会马上收起。已获批的 Master 仍可开／关跟单。",
  demoTrialDays: "Demo 试用日数",
  riskConsentVersion: "风险条款版本",
  pauseService: "暂停",
  resumeService: "恢复",
  closeAllPositions: "全部平仓",
  stopCloudService: "停止云端服务",
  servicePaused: "已暂停",
  serviceStopped: "已停止",
  noStrategyRunning: "未启用策略/跟单",
  copyMasterBadge: "讯源",
  copyFollowBadge: "跟单 · {name}",
  revealAccount: "显示户口",
  hideAccount: "隐藏户口",
  accountCards: "账户服务卡",
  accountRailPrev: "上一张户口",
  accountRailNext: "下一张户口",
  portfolioPerformance: "投资组合表现",
  netEquityDays: "合计权益 · 近 {n} 天",
  netEquityAll: "合计权益 · 所有记录（{n} 天）",
  accountEquityDays: "账户权益 · 近 {n} 天",
  accountEquityAll: "账户权益 · 所有记录（{n} 天）",
  cashDeposit: "入金",
  cashWithdraw: "出金",
  daysShort: "{n}天",
  equityRangeAll: "所有",
  adminAttention: "需要处理",
  attentionCount: "{n} 项",
  attentionClear: "清闲",
  attentionEmpty: "暂时无需处理的事项。",
  attentionBindPending: "绑户待批",
  attentionCopyOfferPending: "开放跟单待批",
  attentionAccountErrors: "账户 offline／error",
  attentionDemoExpiring: "Demo 三日内到期",
  attentionStrategyErrors: "策略执行错误",
  orgTree: "介绍人树状图",
  webPush: "Web Push 通知",
  webPushHint: "批核、Demo 到期等事件会推送到已安装的 PWA，并同步写入消息中心供你回看。与 Telegram Mini App 可以并存。",
  pwaInstallHint: "Chrome：菜单 → 安装 App；iOS Safari：分享 → 加入主屏幕。",
  webPushEnable: "开启推送",
  webPushDisable: "关闭推送",
  webPushOn: "已开启推送",
  webPushOff: "已关闭推送",
  webPushDenied: "浏览器拒绝通知权限",
  webPushNotConfigured: "后台未设定 VAPID 密钥",
  webPushNeedsHttps: "当前网址不是安全环境。Web Push 需要 HTTPS，或本机使用 localhost／127.0.0.1。局域网 IP（http://192.168.x）收不到。",
  webPushLocalhostHint: "本机 Chrome／Edge 用 http://localhost 可以收推送，不需要 HTTPS。必须在这个浏览器点「开启推送」才会订阅；只打开系统设置事件开关不够。Safari 本机 HTTP 不支持。",
  webPushUnsupported: "这个浏览器不支持 Web Push。",
  pushEvents: "Push 事件",
  pushEventsHint: "Admin 可开关哪些事件会发 Web Push／消息中心（绑户／解绑、批核、Demo、策略开平仓／暂停／停止等）。客户可在设置再关细项。",
  savePushEvents: "保存 Push 事件",
  pushPrefs: "通知偏好",
  pushPrefsHint: "选择哪些事件写入消息中心，以及（若已开 Web Push）推到系统通知。策略开／平仓约 30 秒合并一则。",
  pushPrefsSaved: "已更新通知偏好",
  pushPrefAdminOff: "Admin 已关闭此类事件，暂时不会推送。",
  pushPrefsLoadFailed: "加载通知偏好失败。请刷新，或确认引擎已启动。",
  messages: "推送消息",
  messagesHint: "系统推送会保存在这里，未开浏览器通知也可以回看。",
  messagesNote: "显示你账户的推送消息；清空后可在历史数据查看。",
  messagesColTitle: "标题",
  messagesColTime: "创建时间",
  messagesFilterAll: "所有",
  messagesFilterUnread: "未读",
  messagesFilterRead: "已读",
  messagesMarkAllRead: "全部标为已读",
  messagesMarkAllReadDone: "已全部标为已读",
  messagesClear: "清空",
  messagesPurge: "永久删除",
  messagesClearTitle: "清空消息匣",
  messagesClearConfirm: "确定清空当前消息匣？清空后可在「历史数据」回看；解绑凭证等重要内容建议先复制保存。",
  messagesClearHistoryConfirm: "确定永久删除全部历史消息？此操作无法还原。请先自行保存／复制所有重要资料（例如解绑交还的 Server／Login／Master／Investor），删除后系统不会再提供。",
  messagesClearHistoryTitle: "永久删除历史消息",
  messagesCleared: "已清空",
  messagesPurged: "已永久删除",
  cancel: "取消",
  messagesHistory: "历史数据",
  messagesBackInbox: "返回消息匣",
  messagesTotal: "共 {n} 条记录",
  messagesUnreadCount: "未读 {n}",
  messagesPageSize: "每页记录数",
  messagesPageOf: "/ {n}",
  messagesOpenLink: "前往相关页面",
  messagesPrev: "上一则",
  messagesNext: "下一则",
  messagesToastView: "查看",
  messagesToastOne: "新消息：{title}",
  messagesToastMany: "新消息：{title}（共 {n} 则未读）",
  messagesToastFallback: "你有 {n} 则新消息",
  messagesPreviewTitle: "未读消息",
  messagesPreviewEmpty: "暂无未读消息",
  messagesGoInbox: "前往消息匣",
  close: "关闭",
  productPlans: "计划方案",
  productPlansHint: "编辑订阅卡内容（名、价钱、简介、亮点、Stripe link）和连线配额；下面可覆写单一客户。",
  productPlansStripeLater: "之后会对接 Stripe webhook：自动认订阅、到期、累计付费等。现在可先贴 Payment Link。",
  planQuotaHint: "方案卡：名字／价钱／简介／亮点／Stripe link／配额。有改动才出现保存。",
  assignPlanHint: "指派覆写：留空＝跟方案默认；填数字＝只对该客户生效（可以比方案更多）。",
  quotaOverride: "覆写配额",
  unsaved: "未保存",
  defaultPlanOption: "默认",
  assignPlan: "指派方案",
  setDefaultPlan: "设为默认",
  planEnabled: "开卖／显示",
  planDisabled: "已关闭",
  planDisabledHint: "已关闭：客户订阅页不会显示此方案。",
  cannotDisableDefaultPlan: "默认方案不可以关闭；请先改其他方案做默认。",
  subscribe: "订阅",
  subscribeHint: "选付款周期，看三个方案。Stripe Payment Link 接上后可直接付款。",
  billingMonthly: "月付",
  billingQuarterly: "季付",
  billingYearly: "年付",
  billingYearlySave: "年付通常更划算",
  perMonth: "/月",
  perQuarter: "/季",
  perYear: "/年",
  currentPlan: "当前方案",
  yourCurrentPlan: "你当前的方案",
  choosePlan: "选择方案",
  stripeLinkPending: "此周期的 Stripe 付款链接尚未设定，请联系 Admin。",
  stripeLinkPendingShort: "即将开放",
  stripeCheckoutOpened: "已打开付款页",
  stripeLinkAdminHint: "之后贴 Stripe Payment Link；留空＝客户看到「即将开放」。",
  planName: "方案名称",
  planBlurb: "简介",
  planHighlights: "亮点",
  planHighlightsHint: "每行一点；会显示在订阅卡。",
  planNameRequired: "请填写繁中方案名称",
  planPriceInvalid: "请输入有效价钱（≥ 0）",
  price: "价钱",
  currency: "货币",
  strategyExclusions: "策略互斥",
  strategyExclusionsHint: "同一账户不能同时 enable 互斥策略对。",
  strategyExclusionsEmpty: "尚未设定互斥规则。",
  riskTermsAdmin: "风险条款",
  riskTermsAdminHint: "编辑条款正文与 legal review 备注；activate 会要求客户重新 consent。",
  riskTermsBody: "条款正文（繁中）",
  legalReviewNote: "Legal review 备注",
  legalReviewedAt: "Legal review 时间",
  activateTerms: "发布／启用版本",
  yourPlan: "订阅方案",
  investorMissing: "经纪商未允许改密／尚未轮换",
  hide: "隐藏",
  show: "显示",
  confirmMasterRotate: "轮换 master 之后旧密码即时失效，新密码只留引擎，你看不到。继续？",
  masterRotatedMsg: "Master 已轮换，只留引擎。",
  confirmUnbind: "解绑此账户？策略和跟单会一并移除。之后会一次性显示 Server／Login／Master（仅此一次），请立刻保存。",
  autoRotateHint: "自动轮换间距由 Admin 系统设定（小时；0＝不自动）",
  rotateFailed: "改密失败",
  copiedInvestor: "已复制 investor",
  noSessions: "未有 session 记录。",
  sessionTitle: "装置 session · 1 手机 + 1 桌面",
  now: "目前",
  adminAccountsHint: "页顶可向经纪商开 Demo 并绑到所选客户。下面按客户分组，可发送重设登录密码邮件。Master／Investor 用密码栏（眼睛）显示给 admin；客户 API 永远看不到。可直接改 Demo／试用到期日。",
  sendResetEmail: "发送重设邮件",
  confirmSendReset: "向 {email} 发送重设登录密码链接？客户在邮件里打开链接再设新密码。只改 Kairos 门户密码。",
  resetEmailSent: "已发送重设邮件到 {email}",
  expandAccountDetails: "展开跟单资讯与到期日",
  collapseAccountDetails: "收起跟单资讯与到期日",
  revealMaster: "显示 master",
  demoExpiresAt: "到期日",
  clearDemoExpiry: "清空",
  demoExpirySaved: "已更新到期日",
  fetchTradeHistory: "找取交易历史",
  equityBackfillStarted: "已开始回填 #{login} 历史，完成后会通知 Admin。",
  equityBackfillRunning: "回填中…",
  confirmUnbindUser: "解绑 {email} #{login}？",
  noBoundAccounts: "尚未有绑定账户。",
  adminServersHint: "一条服务器可以有多个 host:port。学生只见到别名；连线时系统会按优先次序自动 failover。MT4／MT5、Demo／Live 都可以用同一个别名。",
  symbolAliases: "跟单品种对照",
  symbolAliasesHint: "ECN 的 XAUUSD+ 是后缀，不要加进 GOLD 组。上面随时改前／后缀（+、.sc、#）；引擎用这张表剥名，不再写死在程序里。",
  symbolAffixPrefixes: "前缀",
  symbolAffixSuffixes: "后缀",
  symbolAffixPrefix: "前缀，例如 #",
  symbolAffixSuffix: "后缀，例如 +",
  symbolAffixEmpty: "尚未有",
  symbolAffixSaved: "已加入前后缀",
  symbolAffixRemoved: "已移除前后缀",
  symbolAliasGroups: "同义组",
  symbolAliasGroupsHint: "剥完前后缀之后，同一组可以互对（GOLD↔XAUUSD）。跟单户口同时有两个对得上的名称就不下单。不要把 BTCUSD 和 BTCUSDT 放同一组，也不要把 XAUUSD+ 当别名。",
  symbolAliasCanonical: "标准名",
  symbolAliasExtra: "同义名",
  symbolAliasAdd: "加入",
  symbolAliasAddGroup: "新增一组",
  symbolAliasRemove: "移除",
  symbolAliasDeleteGroup: "删除此组",
  symbolAliasDeleteGroupConfirm: "删除「{canonical}」整组别名？跟单之后只靠后缀对品种。",
  symbolAliasSaved: "已加入别名",
  symbolAliasRemoved: "已移除别名",
  symbolAliasEmpty: "尚未有别名组。下面可以加；空表时系统会预填常见指数／黄金。",
  foundServers: "找到 {n} 条服务器（已按官方名称合并多个 host）",
  searchFailed: "搜索失败",
  importedServer: "已导入 {name}（{n} 个地址）",
  importFailed: "导入失败",
  serverCreated: "已新增服务器",
  createFailed: "新增失败",
  pingTesting: "Ping 测试中…",
  pingDone: "Ping 完成",
  pingFailed: "Ping 失败",
  failed: "失败",
  enterHostPort: "请先输入 host:port，例如 mt5-demo.example.com:443",
  officialHidden: "官方名称（隐藏）",
  endpointsPlaceholder: "多个 host:port，一行一个",
  platform: "平台",
  platformResetHint: "切换 MT4 / MT5 会清空 server login 和 server address，两边不共用。",
  serverLogin: "Server login（官方名称，ConnectEx）",
  serverAddress: "Server address（host:port，一行一个）",
  badAddress: "地址格式不正确",
  endpointAdded: "已新增 {host}:{port}",
  addEndpointFailed: "新增地址失败",
  endpointRemoved: "已移除地址",
  removeFailed: "移除失败",
  confirmDeleteServer: "删除整条「{alias}」？会一并删除 {n} 个 host:port。",
  serverDeleted: "已删除 {alias}",
  deleteFailed: "删除失败",
  datParsed: "servers.dat 解析到 {n} 条服务器，可在下面导入",
  uploadFailed: "上传失败",
  searchResults: "搜索结果（按官方名称合并）",
  officialName: "官方名称",
  endpointCount: "地址数",
  importDemo: "导入 Demo",
  importLive: "导入 Live",
  aliasStudent: "别名（学生见到）",
  boundAccounts: "已绑 {n} 户",
  noOfficial: "无官方名称",
  serverCompanyUnknown: "未填公司名",
  pingAll: "Ping 全部",
  collapseHosts: "收起",
  expandHosts: "展开",
  invites: "邀请码",
  invitesHint: "Admin 批次邀请码。留空代码会自动产生。客户 8 位推荐码也算有效邀请。",
  inviteCodeOptional: "代码（可留空自动产生）",
  maxUses: "次数上限",
  unlimited: "不限",
  createInvite: "新增邀请码",
  inviteCreated: "已新增邀请码",
  inviteNote: "备注",
  deactivate: "停用",
  sourceStrategy: "策略",
  sourceCopy: "跟单 · Kc",
  sourceManual: "人手",
  maxLots: "单笔最多手数",
  dailyMax: "每日最多新仓",
  copyWeight: "跟单比例 %",
  copyFollowingCount: "有 {n} 人跟紧此账户",
  copyFollowingMastersCount: "此账户跟紧 {n} 个 Master",
  copyFollowerLogin: "户口#",
  copyFollowerEquity: "资金额",
  noCopyFollowers: "尚未有人跟紧此账户。",
  noCopyFollowing: "此账户尚未跟别人的单。",
  venuesTitle: "场地",
  venuePlanned: "planned",
  venueMt5: "客户自有经纪商账户",
  venueMt4: "客户自有经纪商 MT4 账户",
  venueBinance: "现货／永续 adapter 预留",
  venueMexc: "现货／永续 adapter 预留",
  venueLedger: "充值内账／任务奖励预留",
  venuesAdminTitle: "场地",
  venuesAdminHint: "开卖可以新绑。软关收起绑定、已绑继续。硬停停策略和跟单新单，不平仓、权益画面照更新。场下面伺服器只显示状态；改个别经纪商去交易伺服器页。planned 场即使开卖也不会接绑户。",
  venueServerCount: "{n} 部服务器",
  noBrokers: "这个场尚未有经纪商。",
  brokerModeSaved: "经纪商状态已更新",
  brokerHardStopConfirm: "硬停会停这只经纪商上面所有策略和跟单新单，不会平仓。已绑 {n} 户。确定？",
  brokerSoftCloseConfirm: "软关之后客户不能再绑这只经纪商；已绑户口继续跑。确定？",
  brokerBindClosed: "此经纪商已关闭，暂不接受新绑户。",
  venueModeOpen: "开卖",
  venueModeSoftClose: "软关",
  venueModeHardStop: "硬停",
  venueCapabilityLive: "live",
  venueBoundAccounts: "{n} 户已绑",
  venuePlannedHint: "未接 adapter，开卖也不会接绑户。",
  venueHardStopConfirm: "硬停会停这个场所有策略和跟单新单，不会平仓。已绑 {n} 户。确定？",
  venueSoftCloseConfirm: "软关之后客户不能再绑这个场；已绑户口继续跑。确定？",
  venueModeSaved: "场地状态已更新",
  venueBindNone: "现在没有开放的场地，请稍后再试或联络管理员。",
  venueBindClosed: "此场地已关闭，暂不接受新绑户。",
  venueHardStopClient: "此场地已硬停，策略和跟单暂停代客下单。",
  pinging: "Ping 中…",
  deleteWhole: "删除整条",
  noEndpoints: "尚未有 host:port，请下面新增。",
  removeEndpoint: "移除地址",
  addEndpoint: "新增地址",
  extraHostPlaceholder: "再加一个 host:port，例如 12.34.56.78:443",
  noServers: "尚未有服务器。先搜索或手动新增。",
  brokerPlaceholder: "经纪商名称，例如 ICMarkets",
  capitalPct: "资金%",
  dateCancel: "取消",
  dateConfirm: "确定",
  dateLast7Days: "过去7天",
  dateLast14Days: "过去14天",
  dateAllHistory: "全部历史",
  dateRangeLabel: "时间范围",
  tradeAccount: "交易账号",
  allAccounts: "全部账号",
  downloadCsv: "下载 CSV",
  filterTitle: "筛选",
  filterAddFields: "添加筛选栏位",
  filterReset: "重置",
  filterQuery: "查询",
  filterAvailable: "可选栏位",
  filterSelected: "已选栏位",
  filterSelectAll: "选择全部",
  filterSearchField: "搜索栏位",
  filterActiveCount: "{n}项",
  filterCommand: "指令",
};

const en: Dict = {
  product: "Kairos",
  tagline: "Institutional trading control plane",
  subtitle: "Trade on the client's own account. One engine for MT5 and exchanges.",
  login: "Sign in",
  register: "Create account",
  logout: "Sign out",
  dashboard: "Dashboard",
  admin: "Admin",
  servers: "Trading servers",
  accounts: "Accounts",
  strategies: "Strategies",
  copy: "Copy",
  referral: "Referral",
  unbind: "Unbind",
  allowCopy: "Allow copy",
  applyCopyOffer: "Apply to offer copy",
  editCopyOffer: "Edit name / description",
  copyOfferTitle: "Strategy name",
  copyOfferDescription: "Short description",
  copyOfferSubmit: "Submit request",
  copyOfferPending: "Copy-offer request pending",
  copyOfferRejected: "Copy-offer request rejected",
  copyOfferApprovedHint: "Approved — you can turn allow-copy on or off. Name and description updates apply immediately.",
  copyOfferWorking: "Submitting request…",
  copyOfferSaving: "Saving…",
  copyOfferOk: "Copy-offer request submitted for admin review.",
  copyOfferUpdated: "Copy listing name and description updated.",
  copyOfferApproveOk: "Copy-offer approved",
  copyOfferRejectOk: "Copy-offer rejected",
  copyOfferRejectConfirm: "Reject copy-offer from {email} #{login}?",
  revokeCopyOffer: "Revoke copy rights",
  revokeCopyOfferConfirm: "Revoke copy-offer rights for {email} #{login}? The client must re-apply before offering copy again.",
  revokeCopyOfferOk: "Copy rights revoked",
  copyOfferNeedApproved: "Copy-offer not approved yet — apply first",
  needOnlineForCopy: "Account must be online on MT5 before it can become a copy master.",
  copyFollowersBlockOff: "{n} client(s) still copy this account. They must unfollow before you can turn off allow-copy.",
  copyFollowersBlockUnbind: "{n} client(s) still copy this account. They must unfollow before you can turn off copy and unbind.",
  unbindNeedDisableCopy: "Turn off allow-copy before unbinding.",
  unbindConsentTitle: "Unbind confirmation and service termination",
  unbindConsentVersion: "v1",
  unbindConsentAgree: "I have read and agree to the unbind notice above.",
  unbindConsentConfirm: "Agree and unbind",
  unbindConsentBody:
    "1. Unbinding ends Kairos execution and strategy/copy hosting for this trading account. We do not custody your funds; funds remain at your chosen broker.\n" +
    "2. After unbind, strategy allocations and copy links on this account are removed or disabled; the system will no longer open, close, or copy trades for you on it.\n" +
    "3. On success, you receive Server name (broker), Login, and Master password once (also stored in your message center). Save them immediately; we do not guarantee full plaintext credentials can be shown again later.\n" +
    "4. After unbind you are solely responsible for that broker account, passwords, and risk. Loss of credentials, third-party use, or broker connection refusal is at your own risk.\n" +
    "5. Unbind is not a broker account closure and does not guarantee immediate re-bind; re-binding may be limited by venue switches, quotas, approval policy, account state, or maintenance.\n" +
    "6. If allow-copy is still on, or other clients still follow this account, you must wait until they unfollow and turn off allow-copy before unbinding.\n" +
    "7. You confirm you have read and understood this notice and agree to end this account’s binding and related services on Kairos.",
  investor: "Investor password",
  bind: "Bind account",
  email: "Email",
  password: "Password",
  showPassword: "Show password",
  hidePassword: "Hide password",
  invite: "Invite code",
  invitePlaceholder: "KAIROS-2026 or 8-char code",
  code: "Verification code",
  verify: "Verify email",
  locale: "Language",
  equity: "Equity",
  balance: "Balance",
  credit: "Credit",
  positions: "Positions",
  status: "Status",
  alias: "Alias",
  environment: "Environment",
  search: "Search brokers",
  import: "Import",
  manual: "Add manually",
  ping: "Ping",
  save: "Save",
  enabled: "Enabled",
  demo: "Demo",
  live: "Live",
  host: "Host",
  port: "Port",
  official: "Official name (hidden from students)",
  company: "Company",
  actions: "Actions",
  mtLogin: "MT5 login",
  accountShort: "Account",
  masterPassword: "Master password",
  studentHint: "Students only see the alias, never the real server address.",
  fetchMt5: "Search via mt5rest",
  fetchMt4: "Search via mt4rest",
  uploadDat: "Upload servers.dat",
  uploadSrv: "Upload .srv / servers.ini",
  requireInvite: "Invite code required",
  socialLogin: "Social sign-in",
  socialLoginHint: "Env vars only make the provider available. These switches must also be on before login / register show the buttons. Turning them off also rejects the APIs.",
  googleLoginEnabled: "Allow Google sign-in / sign-up",
  telegramLoginEnabled: "Allow Telegram sign-in / sign-up",
  googleEnvReady: "Google Client env is set.",
  googleEnvMissing: "GOOGLE_CLIENT_ID / SECRET are empty, so this stays unused even if on.",
  telegramEnvReady: "Telegram Bot env is set.",
  telegramEnvMissing: "TELEGRAM_BOT_TOKEN / USERNAME are empty, so this stays unused even if on.",
  adminSettings: "System settings",
  adminSettingsHint: "Tenant-wide config. Edit freely, then use the bottom Save once. Flash duration applies to everyone; each user can still turn the effect off.",
  loadFailed: "Failed to load",
  saving: "Saving…",
  connectionQuotaInvalid: "Enter a connection quota between 1 and 100",
  demoTrialInvalid: "Enter 0 to 365 days",
  riskConsentVersionInvalid: "Enter a risk consent version",
  adminStrategies: "Strategy products",
  adminStrategiesHint: "Availability, which params the client card exposes, catalog defaults, and who is running. Closing a product does not flatten tickets; changing defaults does not rewrite live allocations.",
  catalogOpen: "On sale",
  catalogClosed: "Soft-closed",
  catalogUnavailable: "This strategy is not currently offered to clients.",
  clientSurface: "Client surface",
  clientSurfaceHint: "Click to cycle Simple → Advanced → Locked → Hidden. Arrows reorder. Save to apply.",
  surfaceSimple: "Simple",
  surfaceAdvanced: "Advanced",
  surfaceLocked: "Locked",
  surfaceHidden: "Hidden",
  liveBook: "Live book",
  liveBookHint: "No real host / master. The params column only shows keys that diverge from catalog.",
  openProduct: "Open",
  softCloseHint: "Soft-close hides the product from the client catalog. Running allocations keep going until they stop or you hard-stop.",
  softCloseConfirm: "{n} accounts are running. Soft-close only hides it from new clients; it will not stop them. Continue?",
  softCloseActive: "Soft-closed: {n} accounts still running.",
  hardStop: "Hard-stop all running",
  hardStopHint: "Stops the strategy only. Does not close tickets.",
  hardStopConfirm: "Stop {name} on {n} running accounts (no flatten). Continue?",
  hardStopDone: "Stopped {n} accounts.",
  catalogDefault: "Default",
  defaultsNotLive: "Default changes apply to new enables and client Reset. Existing allocations are not rewritten.",
  followCatalog: "Matches catalog",
  noLiveAllocations: "No accounts have this strategy assigned.",
  advancedParams: "Advanced params",
  schemaSaved: "Product settings saved.",
  paramKey: "Param",
  clientPreview: "Client card preview",
  vsCatalog: "vs catalog",
  strategyNameField: "Strategy name",
  strategyBlurbField: "Description",
  strategyCopyHint: "Name and blurb on the client strategy card. Fields follow the portal language list. Slug is fixed.",
  editStrategyCopy: "Edit name / blurb",
  collapseStrategyCopy: "Collapse name / blurb",
  nameZhHant: "Name · Traditional Chinese",
  nameZhHans: "Name · Simplified Chinese",
  nameEn: "Name · EN",
  blurbZhHant: "Blurb · Traditional Chinese",
  blurbZhHans: "Blurb · Simplified Chinese",
  blurbEn: "Blurb · EN",
  brokerLogs: "Broker commands",
  brokerLogsJournal: "Journal",
  brokerLogsHint: "Commands the engine sent to mt4rest / mt5rest, plus the HTTP return. Each row records which page and feature issued it. Passwords and Connect URLs are never stored. Worker keep-alive is not written to the database. Quotes are hidden by default.",
  brokerLogsChatter: "Show quotes / keep-alive",
  brokerLogsQuery: "Search command, request, response, or error",
  brokerLogsHours: "Time range",
  brokerErrorsOnly: "Errors only",
  brokerCallerPage: "Source page",
  brokerCallerFeature: "Feature",
  brokerCaller: "Source",
  brokerClearFilters: "Clear all filters",
  brokerShowingCount: "Showing {n}",
  brokerRest: "REST probe",
  brokerRestHint: "Manually call mt4rest / mt5rest reads. The browser never talks to the broker. Writes, password changes, and Connect are not exposed. List payloads render as a table so you can see missing or wrong fields immediately.",
  brokerRestAccount: "Bound account",
  brokerRestSend: "Send",
  brokerRestNeedAccount: "This command uses the engine’s existing session. Pick a bound account first.",
  brokerRestTable: "Table",
  brokerRestJson: "JSON",
  brokerRestRows: "{n} rows",
  brokerRestGroupServer: "Server",
  brokerRestGroupAccount: "Account",
  brokerRestGroupPositions: "Positions",
  brokerRestGroupHistory: "History",
  brokerRestGroupQuotes: "Quotes",
  brokerRestPickCommand: "Pick a command",
  brokerRestSending: "Sending…",
  brokerRestEmpty: "No payload yet. Pick a command and send.",
  last1h: "Last 1 hour",
  last6h: "Last 6 hours",
  last24h: "Last 24 hours",
  last7d: "Last 7 days",
  allPlatforms: "All platforms",
  allCommands: "All commands",
  resultOk: "OK",
  resultError: "Error",
  durationMs: "Duration",
  requestBody: "Sent",
  responseBody: "Returned",
  tickFlashSeconds: "Tick flash seconds",
  tickFlashSecondsHint: "How long the background flash lasts when a figure changes (0.15–3s). Config key: tick_flash_seconds",
  tickFlashSecondsInvalid: "Enter a value between 0.15 and 3 seconds",
  tickFlashEnabled: "Tick flash",
  tickFlashEnabledHint: "Applies to your account only. Config key: tick_flash_enabled",
  seconds: "sec",
  minutes: "min",
  idleTimeoutHint: "Log out after this many minutes with no keyboard or mouse. 0 = never. Config key: idle_timeout_seconds (default 5 minutes)",
  idleTimeoutInvalid: "Enter 0 or more minutes",
  idleLoggedOut: "Signed out after idle timeout. Please sign in again.",
  brokerLogRetentionHint: "How long broker command logs stay in Postgres. 0 = never delete. Config key: broker_log_retention_days (default 7 days)",
  brokerLogRetentionInvalid: "Enter 0 to 365 days",
  days: "days",
  hours: "hours",
  passwordRotateHoursHint: "Auto-rotate investor / master interval (hours). 0 = off. Config: investor_rotate_hours / master_rotate_hours; env INVESTOR_ROTATE_HOURS / MASTER_ROTATE_HOURS (default 12)",
  passwordRotateHoursInvalid: "Enter 0 to 8760 hours",
  bindRotatePasswords: "Rotate passwords on bind (investor + master)",
  bindRotatePasswordsHint: "On: after connect, change investor and rotate master; write DB only after success. Off: skip ChangePassword and store the client-entered master. Clients never see MT passwords while bound; unbind returns a one-time handoff. Config: bind_rotate_passwords; env BIND_ROTATE_PASSWORDS (default off)",
  sessionKicked: "Signed in on another computer. This session was replaced.",
  empty: "No data yet",
  connectOk: "Online",
  connectFail: "Failed",
  googleSoon: "Google sign-in coming soon",
  home: "Home",
  portfolio: "Positions",
  tasks: "Tasks",
  settings: "Settings",
  floating: "Floating P/L",
  winRate: "Open win rate",
  trades: "Fills",
  followers: "Followers",
  following: "Following",
  quotes: "Quotes",
  watchlist: "Watchlist",
  running: "Running",
  stopped: "Off",
  hedge: "Hedge mode · BUY and SELL can sit on the same symbol",
  reward: "Reward",
  planned: "USDT ledger planned · completion is live",
  sessions: "Device sessions",
  currentDevice: "This device",
  copyCode: "Copy",
  liveProof: "Demo and Live share the same bind path. Only the alias changes.",
  pwdOk: "Password policy applied",
  pwdInvestorOk: "Investor applied",
  pwdInvestorDenied: "Investor change refused",
  pwdMasterDenied: "Master rotate refused",
  pwdDenied: "Broker blocked password change",
  pwdPending: "Not rotated yet",
  pwdSkipped: "Bind kept client password (setting off)",
  bindOkSkipped: "Bound. Passwords were not changed; your master stays in the engine.",
  boundNoMtPasswordsHint: "Master/investor are hidden while bound; use Kairos for positions and closes. Unbind hands back Server / Login / Master once.",
  unbindHandoffTitle: "Unbound · Save credentials now",
  unbindHandoffOnce: "Copy and save now. Full credentials are also stored under the bell → Push messages for later review.",
  unbindServerName: "Server name (broker)",
  unbindLogin: "Login",
  unbindMaster: "Master",
  unbindInvestor: "Investor",
  unbindInvestorMissing: "No investor on this account (bind may have skipped password change).",
  unbindHandoffSaved: "I saved them",
  unbindFailed: "Unbind failed",
  copied: "Copied",
  rotateInvestor: "Rotate investor",
  rotateMaster: "Rotate master",
  copyInvestor: "Copy investor",
  masterInEngine: "Master stays in the engine",
  loading: "Loading…",
  pleaseLogin: "Sign in first.",
  needAdmin: "Admin access required.",
  expandSidebar: "Open sidebar",
  collapseSidebar: "Collapse sidebar",
  language: "Language",
  accountsMenu: "Accounts",
  navExecute: "Execute",
  navGrowth: "Growth",
  darkMode: "Dark mode",
  roleClient: "Client",
  roleAdmin: "Admin",
  referralCode: "Referral code",
  avatar: "Avatar",
  avatarHint: "Pick a preset avatar for the top bar and menu.",
  avatarAdminFixed: "Admins use a fixed admin avatar.",
  changeAvatar: "Change avatar",
  marketsLive: "Markets open",
  connecting: "Connecting…",
  loginTitle: "Sign in to the control plane",
  loginHint: "One session for the portal, engine, and MT5 bridge. The browser never talks to the broker.",
  loginFailed: "Sign-in failed",
  noAccount: "No account yet?",
  forgotPassword: "Forgot password",
  forgotTitle: "Reset sign-in password",
  forgotHint: "This resets the Kairos portal password only — not broker Master / Investor. Enter your verified email and we will send a reset link.",
  forgotSent: "If this email is registered, a reset link has been sent. It is valid for 10 minutes.",
  forgotCheckTitle: "Check your email",
  forgotCheckBody: "If {email} is registered, the inbox has a reset link (valid for 10 minutes).",
  sendResetLink: "Send reset link",
  resetHint: "Set a new Kairos sign-in password. This does not change broker Master / Investor.",
  resetInvalid: "This reset link is invalid or expired. Request a new one.",
  devResetLink: "Dev-mode reset link: {link}",
  orDivider: "or",
  resetPassword: "Reset password",
  newPassword: "New password",
  confirmPassword: "Confirm new password",
  passwordMismatch: "The two passwords do not match",
  resetOk: "Password reset. Sign in with the new password.",
  backToLogin: "Back to sign in",
  signInWithGoogle: "Continue with Google",
  signInWithTelegram: "Continue with Telegram",
  oauthNotConfigured: "This sign-in method is not configured. Set the engine env vars and restart.",
  oauthInviteHint: "If new accounts need an invite code, enter it before Google / Telegram.",
  registerInviteHint: "Shared by email, Google, and Telegram sign-up.",
  emailRegister: "Sign up with email",
  errGoogleDisabled: "Google sign-in is not configured.",
  errGoogleDenied: "Google authorization was cancelled.",
  errGoogleNoEmail: "That Google account has no email.",
  errInviteRequired: "New accounts need an invite code. Enter it, then sign in again.",
  errOauthConflict: "This social account is already linked to another user.",
  errGoogleFailed: "Google sign-in failed.",
  registerHint: "Verification email is Traditional / Simplified Chinese plus English. We remember your locale.",
  registerFailed: "Registration failed",
  verifyFailed: "Verification failed",
  sendCode: "Send code",
  finishVerify: "Finish verification",
  codeSent: "A code was sent to {email}",
  devCode: "Dev-mode code: {code}",
  hasAccount: "Already have an account?",
  landingKicker: "Execution OS · MT5 · Exchange-ready",
  landingTitle: "Institutional execution OS",
  landingAccent: "built for live markets.",
  landingBody: "Client funds stay at their broker. Kairos connects, risks, and executes. The same control plane later attaches exchanges.",
  enterSystem: "Enter the system",
  haveAccount: "I have an account",
  pillar1: "Multi-tenant portal, invite codes, two-device sessions. Students only see server aliases.",
  pillar2: "Self-hosted MT5 REST. Demo / Live only swaps the access list, not the engine.",
  pillar3: "Per-account keep-alive, position sync, multi-strategy and copy slots.",
  pillar4: "One control plane reserved for exchange APIs and an internal ledger. Reviewers see one system.",
  liveStack: "Live stack",
  nonCustodial: "Non-custodial first",
  nonCustodialBody: "Only the engine trades with the master password. Students see aliases and the investor view, never the real server name.",
  homeHint: "Equity, positions, and copy counts sync from the engine. The browser only calls the Kairos API.",
  online: "online",
  offline: "offline",
  accountDisabled: "Disabled",
  copyPaused: "Copy paused",
  accountExpired: "Expired",
  accountBrokerDisabled: "The broker disabled or expired this account. The engine stopped reconnecting. Unbind it, then bind a new account.",
  accountDemoExpired: "Demo trial expired; the engine stopped connecting.",
  accountsLabel: "Accounts",
  connection: "Connection",
  miniBlotter: "Mini blotter",
  allPositions: "All positions",
  blotterAccount: "Acct",
  symbol: "Symbol",
  side: "Side",
  pnl: "P/L",
  noPositionsHint: "No open positions. Enable MA breakout on Strategies, or follow a master.",
  goBind: "Go bind",
  bindNav: "Bind",
  noAccountsYet: "No accounts bound yet.",
  allBoundEquity: "All bound accounts",
  openCountHint: "{n} open",
  openWinHint: "Winning open tickets",
  engineFills: "Intents the engine sent",
  followingMasters: "Following {n} masters",
  portfolioHint: "Positions and cash sync from keep-alive. Select an account card to see its blotter.",
  portfolioExpiredTitle: "Account connection has expired",
  portfolioExpiredHint: "This account’s permission to connect to the system has expired, and the engine has stopped connecting. If you still have orders at the broker, please manage them there yourself.",
  noAccountsBind: "No accounts yet. Bind MT5/MT4 under Accounts → Bind.",
  blotter: "Position blotter",
  blotterCountLive: "{live} open",
  blotterCountSplit: "{n} tickets, {live} open, {pending} pending",
  lots: "Lots",
  openPrice: "Open",
  currentPrice: "Last",
  stopLoss: "Stop",
  takeProfit: "Take profit",
  action: "Action",
  source: "Source",
  openTime: "Opened",
  closePosition: "Close",
  closeThisTicket: "Close",
  closeThisTicketConfirm: "Close {symbol} #{ticket}?",
  closeThisTicketDone: "Close sent.",
  deletePendingOrder: "Delete",
  deletePendingOrderConfirm: "Delete pending order {symbol} #{ticket}?",
  deletePendingOrderDone: "Pending order deleted.",
  noPositionsHedge: "No positions. BUY and SELL can sit on the same symbol (hedge).",
  blotterNote: "Last is the account mark (buy=bid, sell=ask). P/L is floating; the broker book is source of truth.",
  sectionCollapse: "Collapse",
  sectionExpand: "Expand",
  batchOps: "Batch close",
  batchGroupCount: "{n} groups",
  batchTotalTickets: "Tickets",
  batchTotalLots: "Total lots",
  batchTotalPnl: "Total P/L",
  batchWinTotal: "Floating winners",
  batchLossTotal: "Floating losers",
  batchLegSummary: "{n} tickets, {lots} lots",
  batchCloseWin: "Winners only",
  batchCloseLoss: "Losers only",
  batchCloseAll: "Close all",
  batchCloseWinConfirm: "Close all {n} winning {symbol} {side} tickets ({lots} lots)?",
  batchCloseLossConfirm: "Close all {n} losing {symbol} {side} tickets ({lots} lots)?",
  batchCloseAllConfirm: "Close all {n} {symbol} {side} tickets ({lots} lots)?",
  batchCloseDone: "Submitted close for {n} tickets.",
  batchClosePartialFailed: "{n} close requests failed.",
  batchEmpty: "No open positions to batch close (pending orders excluded).",
  priceCandles: "Price candles",
  priceCandlesHint: "Drag center to pan (X+Y); drag price scale up/down to zoom Y; timeline drag right/left for bar width; mobile pinch horizontal = time, vertical = price (double-click reset). Open lines + labels stay when entry bar is off-screen; bar detail card top-left (hover/click to pin).",
  priceCandlesTipOpen: "Open",
  priceCandlesTipClose: "Close",
  priceCandlesPinned: "Pinned",
  priceCandlesUnpin: "Unpin",
  priceCandlesClickPin: "Click to pin",
  priceCandlesDragPanel: "Drag panel",
  priceCandlesCollapsePanel: "Collapse controls",
  priceCandlesExpandPanel: "Expand controls",
  priceCandlesLoadFailed: "Chart unavailable.",
  priceCandlesLoadOlder: "Load older candles",
  priceCandlesLoadOlderBusy: "Loading older candles…",
  priceCandlesLoadOlderOk: "Added {n} bars · earliest {time}",
  priceCandlesLoadOlderEmpty: "No older bars from broker",
  priceCandlesLoadOlderFailed: "Load failed: {error}",
  priceCandlesLive: "LIVE",
  priceCandlesNow: "Now",
  priceCandlesLiveOrders: "Live orders",
  priceCandlesHistoryToggle: "Closed trade history (days)",
  priceCandlesHistoryAllHint: "all shows up to 500 closed trades",
  priceCandlesHistoryBusy: "Loading closed trades…",
  priceCandlesHistoryOk: "Loaded {n} closed trades",
  priceCandlesHistoryEmpty: "No closed trades in this range",
  priceCandlesHistoryFailed: "Closed trades failed: {error}",
  pendingStop: "Stop",
  pendingLimit: "Limit",
  pendingStopLimit: "Stop Limit",
  quotesAfterPositions: "No quotes. This account has no open-position symbols.",
  floatingShort: "Floating",
  allocationHint: "One account can run several strategies, each with its own magic/comment. The first one proves open/close.",
  bindFirst: "Bind an account under Accounts → Bind first.",
  maBreakout: "MA breakout",
  maBreakoutBlurb: "Fast MA crossing slow MA opens long/short. This proves the engine can open and close — not a backtest chart.",
  xauHedge: "XAU hedge grid",
  xauHedgeBlurb: "Opens a random first gold ticket. A favourable step adds the same lot and locks basket SL at breakeven plus profit points. An adverse step hedges, then pyramids on two fixed rails with alternating BUY/SELL and Fibonacci lots until breakeven plus profit, then flatten, cool down, and start a new round. MT4/MT5 hedge.",
  stepPoints: "Step (points)",
  profitPoints: "Profit points",
  volumeMult: "2nd-ticket multiplier (then Fibonacci)",
  cooldownSec: "Cooldown (s)",
  trailPct: "Trail %",
  maxLevels: "Max levels / round",
  forceBeSl: "Force BE SL",
  forceBeSlHint: "Off: Path A writes broker SL once after a new fill. On: also OrderModify when a ticket SL differs from the calculated price.",
  magicCommentHint: "Order marks. The engine owns tickets by magic or comment prefix. Magic may be 0 (then ownership is comment-only). Do not collide with copy Kc; flatten old marks before changing.",
  roundPhase: "Round",
  moreStrategies: "More strategies",
  moreStrategiesHint: "The allocation book is reserved. The next strategy is a definition plus a worker branch — no portal rewrite.",
  updateParams: "Update params",
  assignAccount: "Assign to this account",
  paramsHint: "Stop first, edit params, then assign to this account to write the engine. Switching accounts discards unsaved edits.",
  stopToEdit: "Params are locked while running. Stop first.",
  insufficientCapital: "Insufficient equity: need {need}, have {have}",
  capitalRequiredHint: "Account equity must meet this to enable.",
  symbolRequired: "Enter a symbol.",
  paramsSaved: "Saved to this account and started.",
  stop: "Stop",
  positionDetails: "Open positions",
  positionTicketCount: "{n}",
  positionSummaryLine: "{n} · {lots} lots",
  hedgePnlNote: "This strategy may hold BUY and SELL hedges; side PnL offsets. Watch net floating and period PnL for real risk.",
  noStrategyPositions: "No open tickets for this strategy.",
  pauseTrading: "Pause trading",
  resumeTrading: "Resume trading",
  tradePausedHint: "New orders paused. Open tickets still show; you can flatten.",
  tradePausedBadge: "Orders paused",
  closeStrategyPositions: "Close all",
  closeStrategyPositionsConfirm: "Close the strategy tickets listed below? Other strategies and manual tickets stay open.",
  closeStrategyConfirmAction: "Confirm close",
  closeStrategyWorking: "Closing tickets…",
  closeStrategyResultTitle: "Close result",
  closeStrategyClosedCount: "Closed / requested",
  closeStrategyFailedCount: "Failed",
  closeStrategyLotsLabel: "Lots closed",
  closeStrategyProfitLabel: "Floating PnL (pre-close)",
  closeStrategyLotsSum: "{lots} lots",
  closeStrategyProfitSum: "PnL {pnl}",
  closeStrategyItemOk: "Closed",
  closeStrategyItemFail: "Failed",
  closeStrategyDone: "Done",
  strategyPositionsClosed: "Strategy tickets closed.",
  tradingPaused: "Strategy orders paused.",
  tradingResumed: "Strategy orders resumed.",
  resetParams: "Reset",
  stoppedKeepParams: "Strategy stopped on this account. Params are kept.",
  paramsReset: "Restored defaults on screen only. Assign to this account to write them. Switching accounts discards unsaved changes.",
  saveFailed: "Save failed",
  copyHint: "One follower can copy several masters. BUY+SELL on the same symbol stay separate. Only original tickets are copied.",
  followWith: "Follow with #{login}",
  copyFollowerAccount: "Copy account",
  copyDefaultWeight: "Default weight %",
  copyControlHint: "My copies, open book, and activity below all use this account.",
  copyMasterTag: "(Master)",
  copyNoFollowerAccounts: "No follower accounts available. An open copy master cannot follow someone else.",
  copyMasterCannotFollow: "An open copy-master account cannot follow another master.",
  hedgeMode: "Hedge mode",
  teamMaster: "Team master",
  followingNow: "Following",
  followMasterPct: "Follow this master",
  noMasters: "No copy masters yet. Clients must apply and get admin approval before enabling allow-copy on Bind.",
  copyMarket: "Signal market",
  myCopies: "My copies",
  myCopiesEmpty: "This account is not copying anyone yet. Pick a master in the market above.",
  copyBook: "Copied positions",
  copyBookCount: "{n} open",
  copyFloating: "Floating",
  copyActivity: "Copy activity",
  copyActivityHint: "Recent copy opens the engine placed for this account.",
  copyRelations: "Copy links / copied tickets",
  copyFills: "Engine copy fills",
  noFills: "No copy opens yet.",
  updateWeight: "Update %",
  noCopied: "No copied positions on this account yet.",
  stopCopy: "Stop copying",
  stopCopyConfirm: "Stop copying “{name}”? New tickets from this master will stop; open copied positions stay open.",
  stopCopyOk: "Stopped copying",
  copyFailed: "Copy failed",
  referralHint: "Referral codes work as invite codes. Exactly 8 letters or digits, customizable. Commission waits for internal_ledger.",
  customCode: "Custom code",
  customCodeHint: "Exactly 8 letters or digits. Case does not matter.",
  saveCode: "Save code",
  referrer: "Referrer",
  noReferrer: "No referrer",
  setReferrer: "Set referrer",
  unlinkReferrer: "Unlink",
  adminReferralsHint: "Edit who introduced whom. Link by the 8-character code. Cycles are blocked.",
  referrerCode: "Referrer code",
  cycleBlocked: "That link would cycle",
  linkUpdated: "Referral link updated",
  cannotReferSelf: "Cannot refer yourself",
  invitedBy: "Referrer",
  inviteeCount: "Invitees",
  invited: "Invited",
  nextStep: "Next",
  taskCenter: "Task center",
  goComplete: "Go",
  copyReferral: "Copy referral code",
  copied: "Copied",
  inviteList: "Invitees",
  time: "Time",
  noInvitees: "Nobody has used your code yet.",
  taskHint: "Completion is live. USDT redemption is marked planned — not a payout.",
  completed: "Completed",
  accruedUsdt: "Accrued USDT",
  unsettled: "Unsettled",
  done: "Done",
  notDone: "Open",
  rewardUsdt: "Reward {n} USDT",
  ledgerUnwired: "(ledger not wired)",
  ledgerPlanned: "internal_ledger bonus item",
  settingsHint: "Switch language at the bottom-left. Bind and unbind live under Accounts → Bind.",
  passwordSection: "Sign-in password",
  passwordSectionHint: "Change the Kairos portal password. Other devices will be signed out. Broker passwords are unchanged.",
  setPasswordHint: "This account currently signs in with Google / Telegram. Set a password to use email sign-in.",
  currentPassword: "Current password",
  changePassword: "Change password",
  setPassword: "Set password",
  passwordChanged: "Password updated.",
  linkedLogins: "Linked accounts",
  linkedLoginsHint: "After email sign-in, bind or unbind Google / Telegram here. Unlinking does not delete the account.",
  googleAccount: "Google",
  telegramAccount: "Telegram",
  bindGoogle: "Bind Google",
  bindTelegram: "Bind Telegram",
  unbindGoogle: "Unbind Google",
  unbindTelegram: "Unbind Telegram",
  googleLinked: "Linked",
  telegramLinked: "Linked",
  notLinked: "Not linked",
  linkedOk: "Linked.",
  unlinkedOk: "Unlinked.",
  confirmUnlinkGoogle: "Unbind Google? You will sign in with email or Telegram afterwards.",
  confirmUnlinkTelegram: "Unbind Telegram? You will sign in with email or Google afterwards.",
  telegramDomainHint: "The Telegram widget needs an HTTPS domain registered in BotFather. localhost shows Bot domain invalid.",
  bindMt5: "Bind MT5 · DEMO / LIVE",
  bindMt4: "Bind MT4 · DEMO / LIVE",
  bindHint: "Pick an alias, not a host. Environments that need approval probe-connect first; only success is queued for admin. MT passwords stay hidden while bound; unbind returns them once.",
  demoOpenTitle: "Open Demo (Admin)",
  demoOpenHint: "Request a broker Demo and bind it to the selected client (defaults to you). The browser never talks to REST. Brokers that block terminal/API registration will fail — open on their website, then bind from the client bind page. The server list does not disappear when your own quota is full.",
  demoOpenBindTo: "Bind to client",
  demoOpenBindSelf: "you",
  demoOpenQuotaFull: "This client’s Demo quota is full. Pick another client or raise quota on the plan.",
  demoOpenSubmit: "Open Demo and bind",
  demoOpenWorking: "Requesting a Demo from the broker — this can take a minute…",
  demoOpenOk: "Demo opened and bound.",
  demoOpenUnsupported: "This broker does not accept terminal/API demo registration. Open it on their website, then bind from the client bind page.",
  demoOpenConnectFailed: "Demo was created but connect failed. Copy Login/Master and bind from the client bind page, or log in from the MT terminal.",
  demoOpenHandoffTitle: "Demo opened · save credentials",
  demoOpenAdvanced: "Advanced",
  demoOpenDeposit: "Deposit",
  demoOpenLeverage: "Leverage",
  demoOpenName: "Name",
  demoOpenPhone: "Phone",
  demoOpenNoServers: "No Demo servers in the catalog. Add a Demo alias under Admin trading servers.",
  demoOpenCountry: "Country",
  demoOpenCity: "City",
  demoOpenState: "State",
  demoOpenZip: "ZIP",
  demoOpenAddress: "Address",
  bindOkRotated: "Bound. Investor/master handled per policy; passwords stay in the engine.",
  bindOkPartial: "Bound. The broker did not fully allow password change. See status below.",
  bindFailed: "Bind failed",
  bindWorking: "Connecting to the broker to verify the account — this can take up to a minute…",
  bindPending: "Connect OK — bind request submitted, awaiting admin approval.",
  bindQuotaFull: "Quota exhausted",
  bindQuotaUpgrade: "Quota exhausted. Please upgrade your plan.",
  bindQuotaUpgradePrefix: "Quota exhausted. Please",
  bindQuotaUpgradeLink: "upgrade your plan.",
  bindQuotaDemoHidden: "Demo quota is full — alias list shows Live servers only.",
  bindQuotaLiveHidden: "Live quota is full — alias list shows Demo servers only.",
  bindRequests: "Bind approvals",
  bindRequestsHint: "Live binds need approval by default. Clients must probe-connect successfully before the request is queued; approval reconnects and follows bind_rotate_passwords.",
  approve: "Approve",
  approveWorking: "Reconnecting to the broker to finish the bind — this can take up to a minute…",
  approveOk: "Approved — the account is online.",
  approveTimeout: "Approval is still running in the background. Refresh the pending list shortly.",
  reject: "Reject",
  rejectReason: "Reject reason",
  pending: "Pending",
  connectionQuota: "Connection quota",
  connectionQuotaDefault: "Default connections per client",
  demoConnectionQuotaDefault: "Default Demo connections",
  liveConnectionQuotaDefault: "Default Live connections",
  liveBindApproval: "Live bind requires approval",
  demoBindApproval: "Demo bind requires approval",
  quotaCountsExpiredAccounts: "Count expired accounts toward quota",
  quotaCountsExpiredAccountsHint: "Off (default): accounts past the platform calendar day do not occupy a slot, so the client can bind another Demo/Live. On: expired accounts still occupy quota until an admin unbinds them.",
  copyOfferEnabled: "Copy-offer applications",
  copyOfferEnabledHint: "Takes effect immediately. Off: hide “Apply to offer copy” on the bind page and hide related Push / inbox events below. Approved masters can still toggle allow-copy.",
  demoTrialDays: "Demo trial days",
  riskConsentVersion: "Risk terms version",
  pauseService: "Pause",
  resumeService: "Resume",
  closeAllPositions: "Close all",
  stopCloudService: "Stop cloud service",
  servicePaused: "Paused",
  serviceStopped: "Stopped",
  noStrategyRunning: "No strategy / copy",
  copyMasterBadge: "Signal",
  copyFollowBadge: "Copy · {name}",
  revealAccount: "Show account",
  hideAccount: "Hide account",
  accountCards: "Account service cards",
  accountRailPrev: "Previous account",
  accountRailNext: "Next account",
  portfolioPerformance: "Portfolio performance",
  netEquityDays: "Net equity · last {n} days",
  netEquityAll: "Net equity · all history ({n} days)",
  accountEquityDays: "Account equity · last {n} days",
  accountEquityAll: "Account equity · all history ({n} days)",
  cashDeposit: "Deposit",
  cashWithdraw: "Withdraw",
  daysShort: "{n}d",
  equityRangeAll: "All",
  adminAttention: "Needs attention",
  attentionCount: "{n} items",
  attentionClear: "Clear",
  attentionEmpty: "Nothing needs attention right now.",
  attentionBindPending: "Bind requests pending",
  attentionCopyOfferPending: "Copy-offer requests pending",
  attentionAccountErrors: "Accounts offline / error",
  attentionDemoExpiring: "Demo expiring in 3 days",
  attentionStrategyErrors: "Strategy runtime errors",
  orgTree: "Referral org tree",
  webPush: "Web Push",
  webPushHint: "Bind approval, demo expiry, and similar events push to your PWA and are stored in the message center for later review. Works alongside Telegram Mini App.",
  pwaInstallHint: "Chrome: Install app from menu. iOS Safari: Share → Add to Home Screen.",
  webPushEnable: "Enable push",
  webPushDisable: "Disable push",
  webPushOn: "Push enabled",
  webPushOff: "Push disabled",
  webPushDenied: "Notification permission denied",
  webPushNotConfigured: "VAPID keys not configured on server",
  webPushNeedsHttps: "This origin is not a secure context. Web Push needs HTTPS, or localhost / 127.0.0.1 on this machine. A LAN IP such as http://192.168.x cannot receive push.",
  webPushLocalhostHint: "Chrome/Edge on http://localhost can receive push without HTTPS. Click Enable push in this browser to subscribe — toggling events in system settings is not enough. Safari on localhost HTTP does not support push.",
  webPushUnsupported: "This browser does not support Web Push.",
  pushEvents: "Push events",
  pushEventsHint: "Toggle which events write the inbox / Web Push (bind/unbind, approvals, demo expiry, strategy open/close/pause/stop, etc.). Clients can mute subsets in Settings.",
  savePushEvents: "Save push events",
  pushPrefs: "Notification prefs",
  pushPrefsHint: "Choose which events go to the bell inbox and (if Web Push is on) the OS tray. Strategy opens/closes batch for ~30s.",
  pushPrefsSaved: "Notification prefs saved",
  pushPrefAdminOff: "An admin disabled this event globally.",
  pushPrefsLoadFailed: "Could not load notification prefs. Refresh, or check that the engine is up.",
  messages: "Push messages",
  messagesHint: "System pushes are stored here so you can review them even without browser notifications.",
  messagesNote: "Your account push messages. Cleared items move to history.",
  messagesColTitle: "Title",
  messagesColTime: "Created",
  messagesFilterAll: "All",
  messagesFilterUnread: "Unread",
  messagesFilterRead: "Read",
  messagesMarkAllRead: "Mark all read",
  messagesMarkAllReadDone: "All marked as read",
  messagesClear: "Clear",
  messagesPurge: "Delete permanently",
  messagesClearTitle: "Clear inbox",
  messagesClearConfirm: "Clear the inbox? Cleared items remain in History. Copy any important data (e.g. unbound credentials) first.",
  messagesClearHistoryConfirm: "Permanently delete all history? This cannot be undone. Save or copy any important data first (e.g. unbound Server / Login / Master / Investor). After deletion Kairos cannot recover it.",
  messagesClearHistoryTitle: "Delete history permanently",
  messagesCleared: "Cleared",
  messagesPurged: "Permanently deleted",
  cancel: "Cancel",
  messagesHistory: "History",
  messagesBackInbox: "Back to inbox",
  messagesTotal: "{n} records",
  messagesUnreadCount: "{n} unread",
  messagesPageSize: "Per page",
  messagesPageOf: "/ {n}",
  messagesOpenLink: "Open related page",
  messagesPrev: "Previous message",
  messagesNext: "Next message",
  messagesToastView: "View",
  messagesToastOne: "New message: {title}",
  messagesToastMany: "New message: {title} ({n} unread)",
  messagesToastFallback: "You have {n} new messages",
  messagesPreviewTitle: "Unread",
  messagesPreviewEmpty: "No unread messages",
  messagesGoInbox: "Open inbox",
  close: "Close",
  productPlans: "Plans",
  productPlansHint: "Edit subscribe-card copy (name, price, blurb, highlights, Stripe links) and quotas; override per client below.",
  productPlansStripeLater: "Stripe webhooks later (renewal, total paid). Payment Links can be pasted now.",
  planQuotaHint: "Plan cards: name / price / blurb / highlights / Stripe links / quotas. Save appears when dirty.",
  assignPlanHint: "Overrides: leave empty to use the plan default; enter a number for this client only (can exceed the plan).",
  quotaOverride: "Override",
  unsaved: "Unsaved",
  defaultPlanOption: "default",
  assignPlan: "Assign plan",
  setDefaultPlan: "Set default",
  planEnabled: "On sale / visible",
  planDisabled: "Disabled",
  planDisabledHint: "Disabled: hidden from the client subscribe page.",
  cannotDisableDefaultPlan: "The default plan cannot be disabled. Set another plan as default first.",
  subscribe: "Subscribe",
  subscribeHint: "Pick a billing cycle and compare the three plans. Stripe Payment Links enable checkout.",
  billingMonthly: "Monthly",
  billingQuarterly: "Quarterly",
  billingYearly: "Yearly",
  billingYearlySave: "Usually better value yearly",
  perMonth: "/mo",
  perQuarter: "/qtr",
  perYear: "/yr",
  currentPlan: "Current plan",
  yourCurrentPlan: "Your current plan",
  choosePlan: "Choose plan",
  stripeLinkPending: "Stripe checkout for this cycle is not configured yet. Contact admin.",
  stripeLinkPendingShort: "Coming soon",
  stripeCheckoutOpened: "Checkout opened",
  stripeLinkAdminHint: "Paste Stripe Payment Links later; empty = clients see Coming soon.",
  planName: "Plan name",
  planBlurb: "Blurb",
  planHighlights: "Highlights",
  planHighlightsHint: "One bullet per line; shown on the subscribe cards.",
  planNameRequired: "Traditional Chinese plan name is required",
  planPriceInvalid: "Enter a valid price (≥ 0)",
  price: "Price",
  currency: "Currency",
  strategyExclusions: "Strategy exclusions",
  strategyExclusionsHint: "Excluded strategy pairs cannot run enabled on the same account.",
  strategyExclusionsEmpty: "No exclusion rules yet.",
  riskTermsAdmin: "Risk terms",
  riskTermsAdminHint: "Edit body and legal review note; activate forces clients to re-consent.",
  riskTermsBody: "Terms body (zh-Hant)",
  legalReviewNote: "Legal review note",
  legalReviewedAt: "Legal reviewed at",
  activateTerms: "Publish / activate",
  yourPlan: "Your plan",
  investorMissing: "Broker blocked password change / not rotated yet",
  hide: "Hide",
  show: "Show",
  confirmMasterRotate: "Rotating master invalidates the old password immediately. The new one stays in the engine. Continue?",
  masterRotatedMsg: "Master rotated. It stays in the engine.",
  confirmUnbind: "Unbind this account? Strategies and copy links will be removed. You will then see Server / Login / Master once — save them immediately.",
  autoRotateHint: "Auto-rotate interval is set in Admin settings (hours; 0 = off)",
  rotateFailed: "Password change failed",
  copiedInvestor: "Investor copied",
  slot: "Slot",
  lastSeen: "Last seen",
  noSessions: "No session records.",
  sessionTitle: "Device sessions · 1 phone + 1 desktop",
  now: "This device",
  adminAccountsHint: "Open a broker Demo at the top and bind it to a client. Accounts below are grouped by client; you can send a portal password-reset email. Master / Investor show in password fields (eye toggle) for admin only; client APIs never see them. Demo / trial expiry can be edited here.",
  sendResetEmail: "Send reset email",
  confirmSendReset: "Send a sign-in password reset link to {email}? The client opens the email link and sets a new password. This does not change broker passwords.",
  resetEmailSent: "Reset email sent to {email}",
  expandAccountDetails: "Show copy details and expiry",
  collapseAccountDetails: "Hide copy details and expiry",
  revealMaster: "Reveal master",
  demoExpiresAt: "Expiry",
  clearDemoExpiry: "Clear",
  demoExpirySaved: "Expiry updated",
  fetchTradeHistory: "Fetch trade history",
  equityBackfillStarted: "Started backfill for #{login}; admins will be notified when done.",
  equityBackfillRunning: "Backfilling…",
  confirmUnbindUser: "Unbind {email} #{login}?",
  noBoundAccounts: "No bound accounts.",
  adminServersHint: "One logical server can have many host:port rows. Students see the alias; the engine failovers by priority. MT4/MT5 and Demo/Live may share the same alias.",
  symbolAliases: "Copy symbol mapping",
  symbolAliasesHint: "ECN names like XAUUSD+ are a suffix — do not add them to the GOLD group. Edit prefixes/suffixes above (+, .sc, #). The engine reads this table; it is not hardcoded.",
  symbolAffixPrefixes: "Prefixes",
  symbolAffixSuffixes: "Suffixes",
  symbolAffixPrefix: "Prefix, e.g. #",
  symbolAffixSuffix: "Suffix, e.g. +",
  symbolAffixEmpty: "None yet",
  symbolAffixSaved: "Affix added",
  symbolAffixRemoved: "Affix removed",
  symbolAliasGroups: "Synonym groups",
  symbolAliasGroupsHint: "After affixes are stripped, names in the same group map to each other (GOLD ↔ XAUUSD). If the follower book has two matching names, the engine does not order. Do not group BTCUSD with BTCUSDT, and do not store XAUUSD+ as a synonym.",
  symbolAliasCanonical: "Canonical",
  symbolAliasExtra: "Synonym",
  symbolAliasAdd: "Add",
  symbolAliasAddGroup: "Add group",
  symbolAliasRemove: "Remove",
  symbolAliasDeleteGroup: "Delete group",
  symbolAliasDeleteGroupConfirm: "Delete the whole “{canonical}” alias group? Copy will then match suffixes only.",
  symbolAliasSaved: "Alias added",
  symbolAliasRemoved: "Alias removed",
  symbolAliasEmpty: "No alias groups yet. Add one below. An empty table is seeded with common index and gold names.",
  foundServers: "Found {n} servers (hosts merged by official name)",
  searchFailed: "Search failed",
  importedServer: "Imported {name} ({n} endpoints)",
  importFailed: "Import failed",
  serverCreated: "Server created",
  createFailed: "Create failed",
  pingTesting: "Pinging…",
  pingDone: "Ping finished",
  pingFailed: "Ping failed",
  failed: "failed",
  enterHostPort: "Enter host:port, e.g. mt5-demo.example.com:443",
  officialHidden: "Official name (hidden)",
  endpointsPlaceholder: "One host:port per line",
  platform: "Platform",
  platformResetHint: "Switching MT4 / MT5 clears server login and server address. They are not shared.",
  serverLogin: "Server login (official name, ConnectEx)",
  serverAddress: "Server address (one host:port per line)",
  badAddress: "Invalid address",
  endpointAdded: "Added {host}:{port}",
  addEndpointFailed: "Could not add endpoint",
  endpointRemoved: "Endpoint removed",
  removeFailed: "Remove failed",
  confirmDeleteServer: "Delete “{alias}” and its {n} host:port rows?",
  serverDeleted: "Deleted {alias}",
  deleteFailed: "Delete failed",
  datParsed: "servers.dat parsed {n} servers. Import them below.",
  uploadFailed: "Upload failed",
  syncSession: "Syncing session…",
  searchResults: "Search results (merged by official name)",
  officialName: "Official name",
  endpointCount: "Endpoints",
  importDemo: "Import Demo",
  importLive: "Import Live",
  aliasStudent: "Alias (visible to students)",
  boundAccounts: "{n} bound",
  noOfficial: "No official name",
  serverCompanyUnknown: "No company",
  pingAll: "Ping all",
  collapseHosts: "Collapse",
  expandHosts: "Expand",
  invites: "Invite codes",
  invitesHint: "Admin batch invite codes. Leave the code blank to auto-generate. 8-character referral codes also count.",
  inviteCodeOptional: "Code (blank = auto)",
  maxUses: "Max uses",
  unlimited: "Unlimited",
  createInvite: "Create invite",
  inviteCreated: "Invite code created",
  inviteNote: "Note",
  deactivate: "Deactivate",
  sourceStrategy: "Strategy",
  sourceCopy: "Copy · Kc",
  sourceManual: "Manual",
  maxLots: "Max lots",
  dailyMax: "Daily new tickets",
  copyWeight: "Copy %",
  copyFollowingCount: "{n} follower(s) copy this account",
  copyFollowingMastersCount: "This account copies {n} master(s)",
  copyFollowerLogin: "Account #",
  copyFollowerEquity: "Equity",
  noCopyFollowers: "No one is copying this account yet.",
  noCopyFollowing: "This account is not copying anyone.",
  venuesTitle: "Venues",
  venuePlanned: "planned",
  venueMt5: "Client funds stay at their broker",
  venueMt4: "Client MT4 funds stay at their broker",
  venueBinance: "Spot / perp adapter reserved",
  venueMexc: "Spot / perp adapter reserved",
  venueLedger: "Deposit ledger / task rewards reserved",
  venuesAdminTitle: "Venues",
  venuesAdminHint: "Open accepts new binds. Soft-close hides bind; existing accounts keep running. Hard-stop pauses strategy and copy orders without flattening; equity still updates. Servers under a venue show status only; change a broker on the trading-servers page. Planned venues never accept binds, even if set to open.",
  venueServerCount: "{n} servers",
  noBrokers: "No brokers on this venue yet.",
  brokerModeSaved: "Broker mode updated",
  brokerHardStopConfirm: "Hard-stop pauses strategy and copy orders on this broker. Positions stay open. {n} accounts bound. Continue?",
  brokerSoftCloseConfirm: "Soft-close blocks new binds on this broker. Existing accounts keep running. Continue?",
  brokerBindClosed: "This broker is closed and is not accepting new binds.",
  venueModeOpen: "Open",
  venueModeSoftClose: "Soft-close",
  venueModeHardStop: "Hard-stop",
  venueCapabilityLive: "live",
  venueBoundAccounts: "{n} bound",
  venuePlannedHint: "Adapter not live — opening will not accept binds.",
  venueHardStopConfirm: "Hard-stop pauses strategy and copy orders on this venue. Positions stay open. {n} accounts bound. Continue?",
  venueSoftCloseConfirm: "Soft-close blocks new binds on this venue. Existing accounts keep running. Continue?",
  venueModeSaved: "Venue mode updated",
  venueBindNone: "No venue is open right now. Try later or contact admin.",
  venueBindClosed: "This venue is closed and is not accepting new binds.",
  venueHardStopClient: "This venue is hard-stopped. Strategy and copy orders are paused.",
  pinging: "Pinging…",
  deleteWhole: "Delete server",
  noEndpoints: "No host:port yet. Add one below.",
  removeEndpoint: "Remove endpoint",
  addEndpoint: "Add endpoint",
  extraHostPlaceholder: "Another host:port, e.g. 12.34.56.78:443",
  noServers: "No servers yet. Search or add one manually.",
  brokerPlaceholder: "Broker name, e.g. ICMarkets",
  capitalPct: "Capital %",
  dateCancel: "Cancel",
  dateConfirm: "Confirm",
  dateToday: "Today",
  dateYesterday: "Yesterday",
  dateThisWeek: "This week",
  dateLastWeek: "Last week",
  dateThisMonth: "This month",
  dateLastMonth: "Last month",
  dateThisQuarter: "This quarter",
  dateLastQuarter: "Last quarter",
  dateLast7Days: "Last 7 days",
  dateLast14Days: "Last 14 days",
  dateAllHistory: "All history",
  dateRangeLabel: "Date range",
  tradeAccount: "Trading account",
  allAccounts: "All accounts",
  downloadCsv: "Download CSV",
  filterTitle: "Filter",
  filterAddFields: "Add filter fields",
  filterReset: "Reset",
  filterQuery: "Apply",
  filterAvailable: "Available",
  filterSelected: "Selected",
  filterSelectAll: "Select all",
  filterSearchField: "Search fields",
  filterActiveCount: "{n} filters",
  filterCommand: "Command",
};

export const dictionaries: Record<Locale, Dict> = {
  "zh-Hant": zhHant,
  "zh-Hans": zhHans,
  en,
};

export function t(locale: Locale, key: string, vars?: Record<string, string | number>): string {
  let value = dictionaries[locale]?.[key] || dictionaries["zh-Hant"][key] || key;
  if (vars) {
    for (const [name, raw] of Object.entries(vars)) {
      value = value.replaceAll(`{${name}}`, String(raw));
    }
  }
  return value;
}
